import React from "react";
import axios from "axios";
import { Buffer } from "buffer";
import { Router, Switch, Route, withRouter } from "react-router-dom";
import history from "./history";
import Loader from "./components/loader/loader";
import Header from "./components/header/header";
import Footer from "./components/footer/footer";
import Home from "./components/home/home";
import Plan from "./components/plan/plan";
import Successfull from "./components/successfull/successfull";
import Payment from "./components/payment/payment";
import UpdatePayment from "./components/payment/updatePayment";
import UserAccount from "./components/userAccount/useraccount";
import ChangeLocationChangeReginModel from "./components/modal/changeLocationModel";
import OtpPopup from "./components/modal/otpPopup";
import Billing from "./components/billing/billing";
import TermsConditions from "./components/static/terms_conditions";
import Faq from "./components/static/faq";
import * as API from "./configuration/apiconfig";
import CommonErrorPopup from "./components/modal/commonErrorPopup";
import LoyaltyPopup from "./components/modal/loyaltyPopup";
import CongratulationsPopup from "./components/modal/congratulationsPopup";
import Failed from "./components/failed/failed";
import NotifyPopup from "./components/modal/notifyPopup";
import UserGuide from "./components/userguide/userguide";
import TandcPrivacy from "./components/modal/tandcPrivacy";
import PrivacyPolicy from "./components/static/privacy-policy";
import queryString from "query-string";
import LockinpriodPopup from "./components/modal/lockinpriodPopup";
var CryptoJS = require("crypto-js");
const month = [
  { value: "Jan", label: "Jan" },
  { value: "Feb", label: "Feb" },
  { value: "Mar", label: "Mar" },
  { value: "Apr", label: "Apr" },
  { value: "May", label: "May" },
  { value: "Jun", label: "Jun" },
  { value: "Jul", label: "Jul" },
  { value: "Aug", label: "Aug" },
  { value: "Sep", label: "Sep" },
  { value: "Oct", label: "Oct" },
  { value: "Nov", label: "Nov" },
  { value: "Dec", label: "Dec" },
];
const date = [
  { value: "01", label: "01" },
  { value: "02", label: "02" },
  { value: "03", label: "03" },
  { value: "04", label: "04" },
  { value: "05", label: "05" },
  { value: "06", label: "06" },
  { value: "07", label: "07" },
  { value: "08", label: "08" },
  { value: "09", label: "09" },
  { value: "10", label: "10" },
  { value: "11", label: "11" },
  { value: "12", label: "12" },
  { value: "13", label: "13" },
  { value: "14", label: "14" },
  { value: "15", label: "15" },
  { value: "16", label: "16" },
  { value: "17", label: "17" },
  { value: "18", label: "18" },
  { value: "19", label: "19" },
  { value: "20", label: "20" },
  { value: "21", label: "21" },
  { value: "22", label: "22" },
  { value: "23", label: "23" },
  { value: "24", label: "24" },
  { value: "25", label: "25" },
  { value: "26", label: "26" },
  { value: "27", label: "27" },
  { value: "28", label: "28" },
  { value: "29", label: "29" },
  { value: "30", label: "30" },
  { value: "31", label: "31" },
];
const an_month = [
  { value: "Jan", label: "Jan" },
  { value: "Feb", label: "Feb" },
  { value: "Mar", label: "Mar" },
  { value: "Apr", label: "Apr" },
  { value: "May", label: "May" },
  { value: "Jun", label: "Jun" },
  { value: "Jul", label: "Jul" },
  { value: "Aug", label: "Aug" },
  { value: "Sep", label: "Sep" },
  { value: "Oct", label: "Oct" },
  { value: "Nov", label: "Nov" },
  { value: "Dec", label: "Dec" },
];
const an_date = [
  { value: "01", label: "01" },
  { value: "02", label: "02" },
  { value: "03", label: "03" },
  { value: "04", label: "04" },
  { value: "05", label: "05" },
  { value: "06", label: "06" },
  { value: "07", label: "07" },
  { value: "08", label: "08" },
  { value: "09", label: "09" },
  { value: "10", label: "10" },
  { value: "11", label: "11" },
  { value: "12", label: "12" },
  { value: "13", label: "13" },
  { value: "14", label: "14" },
  { value: "15", label: "15" },
  { value: "16", label: "16" },
  { value: "17", label: "17" },
  { value: "18", label: "18" },
  { value: "19", label: "19" },
  { value: "20", label: "20" },
  { value: "21", label: "21" },
  { value: "22", label: "22" },
  { value: "23", label: "23" },
  { value: "24", label: "24" },
  { value: "25", label: "25" },
  { value: "26", label: "26" },
  { value: "27", label: "27" },
  { value: "28", label: "28" },
  { value: "29", label: "29" },
  { value: "30", label: "30" },
  { value: "31", label: "31" },
];

class App extends React.Component {
  constructor(props) {
    let getQuery = queryString.parse(window.location.search);
    super(props);
    this.headerHeight = React.createRef();
    this.step2 = React.createRef();
    this.step3 = React.createRef();
    this.step4 = React.createRef();
    this.state = {
      cmxWebsite_LoginQuery: getQuery.email,
      cmxWebsite_key: "CMXCinema-CMXPassport-microsite",
      cmxWebsite_LoginMailId: "",
      loader: false,
      headerC_SH: true,
      footerC_SH: false,
      header_homeSH: false,
      mobileMenu_SH: false,
      mobileBtmMenu_SH: false,
      searchInputValue: "",
      home_searchData: [],
      plan_pageModalSH: false,
      p_step1: true,
      p_step2: false,
      p_step3: false,
      p_step4: false,
      CL_ModalSH: false,
      CR_ModalSH: false,
      CR_TL_ModalSH: false,
      All_theatre_ModalSH: false,
      AnnualBenefits: false,
      MonthlyBenefits: false,
      payment_overlay: false,
      eyeIcon: false,
      ua_pwdEyeIcon: false,
      ua_cPwdeyeIcon: false,
      hpn_stateSelectValue: null,
      ua_birthMonthSelectValue: null,
      ua_DateSelectValue: null,
      ua_YearSelectValue: null,
      ua_cinemaSelectValue: null,
      an_monthSelectValue: null,
      an_dateSelectValue: null,
      an_yearSelectValue: null,
      ua_rewardsTab: ["Rewards Number", "Mobile Number", "Email Address"],
      whatCardType: [
        {
          title: "Movie Goer",
          cardType: 25000,
        },
        {
          title: "Club Cine",
          cardType: 25010,
        },
        {
          title: "Liberty Loyalty Rewards",
          cardType: 31417,
        },
      ],
      ua_rewardsTabIndex: -1,
      ua_rewardsPlaceholder: "Enter your full rewards number, including zeros",
      focusClass: false,
      otp_pageModalSH: false,
      otp: "",
      locationsJson: [],
      locationUniqueState: [],
      allTheatreUniqueState: [],
      loc_planJson: [],
      loc_name: "",
      planStartPrice: "",
      partyPriceArray: [],
      locPopupIndex: -1,
      plan_regionsJson: [],
      plan_allTheatreJson: [],
      regionsPopupData: [],
      regionPlanData: "",
      allLoc_Name: "",
      allRegion_Firstplans: "",
      regionFirstPlan: [],
      CR_applyJson: false,
      CR_getIndex: 0,
      // CR_getIndex: 1,
      applyBtnDisabled: false,
      region_firstObj: [],
      billingGetPriceObj: [],
      forgotSH: false,
      tc: [
        {
          header: false,
          useraccount: false,
          payment: false,
        },
      ],
      iAccept: true,
      // iAgree: false,
      iAgree: true,
      firstname: "",
      fnErrorMsg: "",
      lastname: "",
      lnErrorMsg: "",
      signUpEmailValue: "",
      emailErrorMsg: "",
      signUpCorrectEmailValue: false,
      loyaltyCorrectEmailValue: false,
      signUpPasswordValue: "",
      signUpPasswordValidation: "",
      signUp_PasswordErrorMsgSH: "",
      signUpConfirmPasswordValue: "",
      signUpConfirmPasswordValidation: "",
      signUp_ConfirmPasswordErrorMsgSH: "",
      signUp_Mobile10Digits: false,
      loylty_Mobile10Digits: false,
      signUpMobileValue: "",
      signUpHomeMobileValue: "",
      mobileErrorMsg: "",
      address1: "",
      address2: "",
      cityValue: "",
      zipCode: "",
      zipErrorMsg: "",
      an_API_Month: "",
      birth_API_Month: "",
      commonErrorMsg: "",
      commonErrorPoupSH: false,
      loyaltyPopupSH: false,
      congratsPopupSH: false,
      registerAPI: [],
      otpAPI: [],
      otpErrorFlag: false,
      otpResendAPI: [],
      signInEmailValue: "",
      signInCorrectEmailValue: false,
      signInEmailErrorMsg: "",
      signInPasswordValue: "",
      signInPasswordErrorMsg: "",
      loginAPI: [],
      forgotEmailValue: "",
      forgotCorrectEmailValue: "",
      forgotEmailErrorMsg: "",
      memberIDTabsSH: false,
      memberIDReadOnly: false,
      withOut_MMRBtnTCSH: false,
      register_BtnTCSH: true,
      tokenAPI: [],
      signup_cinemaLocation: [],
      signup_PLDropdown: [],
      getCinemaId: "",
      withOut_PLName: "",
      movieVisitsCount: 0,
      CMXVisitsCount: 0,
      updateMemberShipAPI: [],
      tcErrorMsg: "",
      year_Calculation: [],
      planPrice: "",
      LltyMoleEmail_Value: "",
      loyltyErrorMsg: "",
      check_PD_ComponentSH: false,
      loyalty_CardType: 25000,
      loyaltyAPI: [],
      loyaltyPopupIndex: "",
      loyaltyNumber: "",
      okBtnSH: false,
      filterLoyaltyObj: [],
      loyaltyMemberIDReadOnly: false,
      checkBtnActive: false,
      registerAPI_withoutLogin: [],
      getLocationId: "",
      getRegionId: "",
      getStateVal: "",
      createAPI: [],
      paymentInitAPI: [],
      paymentPayAPI: [],
      paymentIframeSrc: "",
      paymentSessionKey: "",
      paymentKeys: "",
      paymentType: "",
      paymentNameOnCard: "",
      step1_content: "",
      choosePlanName: "annually",
      stateJson: [],
      taxAPI: [],
      pay_TaxVal: "",
      pay_FeeVal: "",
      pay_FeeCal: "",
      notifyCorrectEmailValue: false,
      notifyEmailValue: "",
      notifyPopupSH: false,
      lockPopupSH: false,
      tncPrivacyPopupSH: false,
      getHomePlanJosn: "",
      changeLocationPlan: "",
      homeGetPlanJson: "",
      getCurrentPlanJson: "",
      planId: "",
      planState_Store: [],
      annually_ActiveClass: true,
      monthly_ActiveClass: false,
      notifySH: false,
      notifyAPI: [],
      correctedTaxValue: 0,
      correctedFeeValue: 0,
      faqjson: [],
      updatePaymentNameOnCard: "",
      redirectfromapp: true,
      regionUniquePopup: [],
      createAPI_getID: [],
      create_locationID: "",
      create_locationName: "",
      step1_id: "",
      step1_name: "",
      step1_value: "",
      step2_name: "",
      step2_subname: "",
      step2_value: "",
      step3_name: "",
      step3_value: "",
      step4_name: "",
      step4_value: "",
      p_tandc: false,
      p_privacy: false,
      homeSettingsAPI: []
    };
  }

  componentDidMount = () => {
    this.settingsLoyaltyLocationsAPI();
    this.home_searchDataFun();
    this.GetAllTheatresLoadFun();
    this.iphoneAndroidShowPlaystore();
    this.CMXWebsiteLogin();
    
    // Footer hide > resize
    // this.footerHide_resizeFun();
    // window.addEventListener("resize", this.footerHide_resizeFun.bind(this));
    window.addEventListener("scroll", this.handlePageScroll);
  };

  componentWillUnmount() {
    // window.removeEventListener("resize", this.footerHide_resizeFun.bind(this));
    window.removeEventListener("scroll", this.handlePageScroll);
  }

  headerHideFun = () => {
    this.setState({
      headerC_SH: false,
    });
  };

  footerHideFun = () => {
    this.setState({
      footerC_SH: false,
    });
  };

  iphoneAndroidShowPlaystore = () => {
    // console.log(document.location.href);
    if (document.location.href.indexOf("redirectfromapp=true") > 0) {
      this.setState({
        redirectfromapp: false,
      });
    }
  };

  preferredLocation_TokenAPI = () => {
    this.setState({
      loader: true,
    });
    const username = process.env.REACT_APP_TOKEN_CINEMA_USERNAME;
    const password = process.env.REACT_APP_TOKEN_CINEMA_PASSWORD;
    const token = Buffer.from(`${username}:${password}`, "utf8").toString("base64");
    const headers = {
      Authorization: `Basic ${token}`,
    };
    const bodyRequest = {
      accessTokenExpiry: "2000",
      keepMeSignedIn: false,
      getUserInfo: false,
    };
    axios
      .post(process.env.REACT_APP_TOKEN_CINEMA_BASEURL + "/user/v1/token", bodyRequest, { headers })
      .then((response) => {
        // console.log(response.data);
        this.setState(
          {
            tokenAPI: response.data,
            loader: false,
          },
          () => {
            this.signup_preferredLocationDropdown();
          }
        );
      })
      .catch((ex) => {
        console.log(ex.response.data.message);
        this.setState({
          commonErrorMsg: ex.response.data.message,
          commonErrorPoupSH: true,
          loader: false,
        });
      });
  };

  signup_preferredLocationDropdown = () => {
    const token = this.state.tokenAPI.accessToken;
    const headers = {
      Authorization: `Bearer ${token}`,
      appplatform: "WEBSITE",
      appversion: "1.0.0",
    };
    axios
      .get(process.env.REACT_APP_TOKEN_CINEMA_BASEURL + "/cms/v1/cinemas", { headers })
      .then((response) => {
        // console.log(response.data);
        this.setState(
          {
            signup_cinemaLocation: response.data,
          },
          () => {
            var arrayPush = [];
            response.data = this.state.signup_cinemaLocation
              .sort((a, b) => (a.cinemas_locations[0].city.toUpperCase() > b.cinemas_locations[0].city.toUpperCase() ? 1 : -1))
              .map((cinemaData, index) => {
                var obj = new Object();
                obj.value = cinemaData.cinemas_attributes[0].name + " - " + cinemaData.cinemas_locations[0].city;
                obj.label = cinemaData.cinemas_attributes[0].name + " - " + cinemaData.cinemas_locations[0].city;
                obj.cinemaId = cinemaData.cinemas_attributes[0].pid;
                arrayPush.push(obj);
                this.setState({
                  signup_PLDropdown: arrayPush,
                });
              });

            // this.state.signup_cinemaLocation.map((cinemaData, index) => {
            //   var obj = new Object;
            //   obj.value = cinemaData.cinemas_attributes[0].name +' - '+ cinemaData.cinemas_locations[0].city
            //   obj.label = cinemaData.cinemas_attributes[0].name +' - '+ cinemaData.cinemas_locations[0].city
            //   obj.cinemaId = cinemaData.cinemas_attributes[0].pid
            //   arrayPush.push(obj);
            //   this.setState({
            //     signup_PLDropdown: arrayPush
            //   })
            // })
          }
        );
      })
      .catch((ex) => {
        console.log(ex.response.data.message);
        this.setState({
          commonErrorMsg: ex.response.data.message,
          commonErrorPoupSH: true,
        });
      });
  };

  h_menu = () => {
    this.setState({ mobileMenu_SH: true });
  };
  h_closeBtn = () => {
    this.setState({ mobileMenu_SH: false });
  };
  h_goHome = () => {
    window.location.href = "/";
  };

  home_mobileClick = () => {
    this.setState({ mobileBtmMenu_SH: true });
  };

  home_btmCloseBtn = () => {
    this.setState({ mobileBtmMenu_SH: false });
  };

  home_searchInputChange = (event) => {
    var inputVal = event.target.value;
    this.setState((prevState) => {
      var filteredLocation = prevState.locationsJson.filter((element) => {
        // var searchOption = element.city + element.mallname + element.theater;
        var searchOption = element.name + element.address1 + element.address2 + element.city + element.state + element.zipcode;
        return searchOption.toLowerCase().includes(inputVal.toLowerCase());
      });
      if (inputVal == "") {
        this.setState({
          home_searchData: [],
          loc_planJson: [],
          notifySH: false,
        });
      }
      return {
        searchInputValue: inputVal,
        home_searchData: filteredLocation,
      };
    });
  };

  home_searchDataFun = () => {
    // locations JSON
    axios
      .get(process.env.REACT_APP_LOCATIONSJSON)
      .then((response) => {
        let locationSorted = response.data.sort((a, b) => (a.city > b.city ? 1 : -1));

        this.setState(
          {
            locationsJson: locationSorted,
          },
          () => {
            var getUniqueState = [...new Set(this.state.locationsJson.map((item) => item.state))];
            var array = [];
            this.state.locationsJson.map((data, index) => {
              if (data.subscriptionEnabled == true) {
                // console.log(data.state)
                array.push(data.state);
                let uniqueChars = [...new Set(array)].sort();
                // console.log(uniqueChars)
                this.setState({
                  locationUniqueState: uniqueChars,
                });
              }
            });
            this.setState({
              allTheatreUniqueState: getUniqueState.sort(),
            });
          }
        );
      })
      .catch((ex) => {
        console.log(ex.response);
      });
  };

  home_locationClick = (e, locData) => {
    if (locData.subscriptionEnabled == true) {
      axios
        .get(locData.plan)
        .then((response) => {
          this.setState(
            {
              loc_planJson: response.data,
            },
            () => {
              this.setState({
                loc_name: locData.name,
                home_searchData: [],
                searchInputValue: locData.name,
                getLocationId: locData.id,
                create_locationName: locData.name,
                create_locationID: locData.id,
                getRegionId: locData.regionid,
                getStateVal: locData.state,
                planStartPrice: this.getPrice(true, false, 1, 0, "monthly", "location"),
                partyPriceArray: [
                  this.getPrice(true, false, 1, 1, "monthly", "location"),
                  this.getPrice(true, false, 1, 2, "monthly", "location"),
                  this.getPrice(true, false, 1, 3, "monthly", "location"),
                ],
                getHomePlanJosn: locData.plan,
                notifySH: false,
              });
            }
          );
        })
        .catch((ex) => {
          console.log(ex.response);
        });
    } else {
      this.setState({
        notifySH: true,
        home_searchData: [],
      });
    }
  };

  getPrice = (monThu, allday, visits, quests, period, type) => {
    var parentJson;
    if (type == "location") {
      parentJson = this.state.loc_planJson;
      // console.log('location');
    } else if (type == "region") {
      if (this.state.CR_applyJson == true) {
        parentJson = this.state.regionFirstPlan;
        // console.log('region if');
      } else {
        parentJson = this.state.regionFirstPlan;
        // console.log('region else');
      }
    } else if (type == "allTheatre") {
      parentJson = this.state.plan_allTheatreJson;
      // console.log('allTheatre');
    }

    var newArray = parentJson.filter(function (el) {
      return (
        el.monThu == monThu &&
        el.allDay == allday &&
        //  el.visitors == visits &&
        el.visits == visits &&
        el.guests == quests &&
        el.period.toLowerCase() == period
      );
    });
    // console.log(newArray);
    if (newArray.length > 0) {
      return newArray[0].price;
    }
  };

  getRegisterId = (monThu, allday, visits, quests, period) => {
    var parentJson = this.state.loc_planJson;
    var newArray = parentJson.filter(function (el) {
      return (
        el.monThu == monThu &&
        el.allDay == allday &&
        // el.visitors == visits &&
        el.visits == visits &&
        el.guests == quests &&
        el.period.toLowerCase() == period
      );
    });
    console.log(newArray);
    return newArray;
    // if(newArray.length > 0){
    //   return newArray[0].id;
    // }
  };

  footerHide_resizeFun() {
    if (window.innerWidth < 768) {
      this.setState({ footerC_SH: false });
    } else {
      this.setState({ footerC_SH: true });
    }
  }

  handlePageScroll = () => {
    var valScrollTop = window.scrollY;
    const siteWrapper = document.querySelector(".wrapper");
    if (valScrollTop > 50) {
      if (siteWrapper.classList.contains("header-sticky") === false) {
        siteWrapper.classList.add("header-sticky");
      }
    } else {
      if (siteWrapper.classList.contains("header-sticky")) {
        siteWrapper.classList.remove("header-sticky");
      }
    }
  };

  customPlan = () => {
    history.push("/plan");
    this.GetAllLocationsJson();
  };

  Home_NotifyMailOnChange = (e) => {
    const regexp = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    const eValue = e.target.value;
    const eName = e.target.name;
    if (regexp.test(eValue) == true) {
      console.log("Email True");
      this.setState({
        notifyCorrectEmailValue: true,
      });
    } else {
      console.log("Email false");
      this.setState({
        notifyCorrectEmailValue: false,
      });
    }
    this.setState({
      [eName]: eValue,
    });
  };

  Home_NotifyOnblur = () => {
    if (this.state.notifyCorrectEmailValue == false) {
      this.setState({
        notifyemailErrorMsg: "Please enter the email.",
      });
    } else {
      this.setState({
        notifyemailErrorMsg: "",
      });
    }
  };

  notifyBtnDisabled = () => {
    var disabled = false;
    if (this.state.notifyEmailValue == "" || this.state.notifyCorrectEmailValue == false) {
      disabled = true;
    }
    return disabled;
  };

  Plan_changeLocationModel = () => {
    this.setState({
      plan_pageModalSH: true,
      CL_ModalSH: true,
      CR_ModalSH: false,
      CR_TL_ModalSH: false,
      All_theatre_ModalSH: false,
      AnnualBenefits: false,
      MonthlyBenefits: false,
    });
  };

  Plan_outsideModelClick = () => {
    this.setState({ plan_pageModalSH: true });
  };

  plan_CL_closeBtn = () => {
    this.setState({
      plan_pageModalSH: false,
      // CR_applyJson: false,
      CR_applyJson: true,
      applyBtnDisabled: false,
    });
  };

  Plan_changeRegion = () => {
    this.setState({
      plan_pageModalSH: true,
      CL_ModalSH: false,
      CR_ModalSH: true,
      CR_TL_ModalSH: false,
      All_theatre_ModalSH: false,
      applyBtnDisabled: false,
      AnnualBenefits: false,
      MonthlyBenefits: false,
    });
    this.GetAllLocationsJson();
  };

  plan_onChangeFun = (e, getFold) => {
    let getHeight = this.headerHeight.current.offsetHeight;
    if (getFold == "step1") {
      setTimeout(() => {
        window.scrollTo(0, this.step2.current.offsetTop - getHeight);
      }, 200);
      this.setState({ p_step2: true });
    } else if (getFold == "step2") {
      setTimeout(() => {
        window.scrollTo(0, this.step3.current.offsetTop - getHeight);
      }, 200);
      this.setState({ p_step3: true });
    } else if (getFold == "step3") {
      setTimeout(() => {
        window.scrollTo(0, this.step4.current.offsetTop - getHeight);
      }, 200);
      this.setState({ p_step4: true });
    }
  };

  payment_tapToView = () => {
    this.setState({ payment_overlay: true });
  };

  payment_closeBtn = () => {
    this.setState({ payment_overlay: false });
  };

  ua_eyeIcon = (eyeValue) => {
    if (eyeValue == "login") {
      this.setState({ eyeIcon: !this.state.eyeIcon });
    } else if (eyeValue == "ua-pwd") {
      this.setState({ ua_pwdEyeIcon: !this.state.ua_pwdEyeIcon });
    } else if (eyeValue == "ua-cpwd") {
      this.setState({ ua_cPwdeyeIcon: !this.state.ua_cPwdeyeIcon });
    }
  };

  us_hpnStateOnchange = (hpn_stateSelectedOption) => {
    this.setState({
      hpn_stateSelectValue: hpn_stateSelectedOption,
    });
  };

  ua_birthMonthOnchange = (monthOption) => {
    this.setState({
      ua_birthMonthSelectValue: monthOption,
    });
    var month = [
      { month: "Jan", num: "01" },
      { month: "Feb", num: "02" },
      { month: "Mar", num: "03" },
      { month: "Apr", num: "04" },
      { month: "May", num: "05" },
      { month: "Jun", num: "06" },
      { month: "Jul", num: "07" },
      { month: "Aug", num: "08" },
      { month: "Sep", num: "09" },
      { month: "Oct", num: "10" },
      { month: "Nov", num: "11" },
      { month: "Dec", num: "12" },
    ];
    {
      month
        .filter((month) => month.month == monthOption.value)
        .map((filteredMonth) =>
          // console.log(filteredMonth.num)
          this.setState({
            birth_API_Month: filteredMonth.num,
          })
        );
    }
  };

  ua_dateOnchange = (dateOption) => {
    this.setState({
      ua_DateSelectValue: dateOption,
    });
  };

  ua_yearOnchange = (yearOption) => {
    this.setState({
      ua_YearSelectValue: yearOption,
    });
  };

  ua_cinemaOnchange = (cinemaOption) => {
    this.setState({
      ua_cinemaSelectValue: cinemaOption,
    });
    var temp = this.state.signup_PLDropdown;
    {
      temp
        .filter((cinemaData) => cinemaData.value == cinemaOption.value)
        .map((filteredId) =>
          // console.log(filteredId.cinemaId)
          this.setState({
            getCinemaId: filteredId.cinemaId,
          })
        );
    }
  };

  ua_an_monthOnchange = (an_monthOption) => {
    this.setState({
      an_monthSelectValue: an_monthOption,
    });
    var month = [
      { month: "Jan", num: "01" },
      { month: "Feb", num: "02" },
      { month: "Mar", num: "03" },
      { month: "Apr", num: "04" },
      { month: "May", num: "05" },
      { month: "Jun", num: "06" },
      { month: "Jul", num: "07" },
      { month: "Aug", num: "08" },
      { month: "Sep", num: "09" },
      { month: "Oct", num: "10" },
      { month: "Nov", num: "11" },
      { month: "Dec", num: "12" },
    ];
    {
      month
        .filter((month) => month.month == an_monthOption.value)
        .map((filteredMonth) =>
          // console.log(filteredMonth.num)
          this.setState({
            an_API_Month: filteredMonth.num,
          })
        );
    }
  };

  ua_an_dateOnchange = (an_dataOption) => {
    this.setState({
      an_dateSelectValue: an_dataOption,
    });
  };

  ua_an_yearOnchange = (an_yearOption) => {
    this.setState({
      an_yearSelectValue: an_yearOption,
    });
  };

  ua_counterBtnClick = (event, counterFlag, visitFlag) => {
    var curObj = event.target;
    var parentObj = curObj.closest(".plus-minus-blk");
    var counterQuantity = parseInt(parentObj.querySelector("input.input-field").value);
    if (counterFlag == "plus") {
      counterQuantity = counterQuantity + 1;
      if (counterQuantity > 0 && parentObj.classList.contains("iczActive")) {
        parentObj.classList.remove("iczActive");
        var a = parentObj.querySelector(".icControl.iccDecrement").classList.remove("disabled");
      }
    } else {
      counterQuantity = counterQuantity > 0 ? counterQuantity - 1 : 0;
      if (counterQuantity <= 0 && !parentObj.classList.contains("iczActive")) {
        parentObj.classList.add("iczActive");
        parentObj.querySelector(".icControl.iccDecrement").classList.add("disabled");
      }
    }
    parentObj.querySelector("input.input-field").value = counterQuantity;
    if (visitFlag == "movieVisits") {
      this.setState({
        movieVisitsCount: counterQuantity,
      });
    } else if (visitFlag == "CMXVisits") {
      this.setState({
        CMXVisitsCount: counterQuantity,
      });
    }
  };

  joinCMXTab = () => {
    this.setState({
      LltyMoleEmail_Value: "",
      check_PD_ComponentSH: false,
      // movieVisitsCount: 0,
      // CMXVisitsCount: 0,
      ua_DateSelectValue: null,
      ua_birthMonthSelectValue: null,
      ua_YearSelectValue: null,
      ua_cinemaSelectValue: null,
      an_dateSelectValue: null,
      an_monthSelectValue: null,
      an_yearSelectValue: null,
      checkBtnActive: false,
      signUpPasswordValue: "",
    });
    // this.stateClear_formFields();
    if (this.state.commonErrorMsg == "The user already exists. Please try to login or register a new account.") {
      this.stateClear_formFields();
    }
  };

  ua_rewardsTabClick = (e, getIndex) => {
    this.setState({
      ua_rewardsTabIndex: getIndex,
      loyltyErrorMsg: "",
      LltyMoleEmail_Value: "",
      check_PD_ComponentSH: false,
      movieVisitsCount: 0,
      CMXVisitsCount: 0,
      ua_DateSelectValue: null,
      ua_birthMonthSelectValue: null,
      ua_YearSelectValue: null,
      an_dateSelectValue: null,
      an_monthSelectValue: null,
      an_yearSelectValue: null,
      checkBtnActive: false,
      signUpPasswordValue: "",
    });
    this.stateClear_formFields();
    if (getIndex == 0) {
      this.setState({
        ua_rewardsPlaceholder: "Enter your full rewards number, including zeros",
        loyalty_CardType: 25000,
      });
    } else if (getIndex == 1) {
      this.setState({
        ua_rewardsPlaceholder: "Enter your mobile number",
      });
    } else if (getIndex == 2) {
      this.setState({
        ua_rewardsPlaceholder: "Enter your email address",
      });
    }
  };

  ua_passwordPolicyFocus = () => {
    this.setState({ focusClass: true });
  };

  ua_passwordPolicyBlur = () => {
    this.setState({ focusClass: false });
    if (this.state.signUpPasswordValue == "") {
      this.setState({
        signUp_PasswordErrorMsgSH: "Please enter the password.",
      });
    } else if (this.state.signUpPasswordValidation == true) {
      this.setState({
        signUp_PasswordErrorMsgSH: "",
      });
    } else {
      this.setState({
        signUp_PasswordErrorMsgSH: "Please refer the password policy.",
      });
    }
  };

  otp_ModalClick = () => {
    this.setState({
      // otp_pageModalSH: true,
      otp: "",
      loader: true,
    });

    API.callEndpoint("POST", "Basic", "", "/subscriber/v1/register", {
      email: this.state.signUpEmailValue,
      password: this.state.signUpPasswordValue,
      firstname: this.state.firstname,
      lastname: this.state.lastname,
      type: "CINEMACUSTOMER",
      accountImage: "",
      mobile: this.state.signUpMobileValue.replace(/[- )(]/g, ""),
      // dob: this.state.ua_DateSelectValue.value+'-'+this.state.birth_API_Month+'-'+this.state.ua_YearSelectValue.value,
      dob: this.state.birth_API_Month + "/" + this.state.ua_DateSelectValue.value + "/" + this.state.ua_YearSelectValue.value,
      favLocations: [],
      favGenres: [],
      planname: "",
      additionaldetails: {
        homephoneno: this.state.signUpHomeMobileValue != "" ? this.state.signUpHomeMobileValue.replace(/[- )(]/g, "") : "",
        planname: "",
        anniversaryDate:
          this.state.an_dateSelectValue != null && this.state.an_API_Month != "" && this.state.an_yearSelectValue != null
          ? this.state.an_API_Month + "/" + this.state.an_dateSelectValue.value + "/" + this.state.an_yearSelectValue.value
          : "",
        preferredLocation: this.state.getCinemaId,
        existingMembershipId: "",
        address1: this.state.address1,
        address2: this.state.address2,
        gender: "",
        state: this.state.hpn_stateSelectValue != null ? this.state.hpn_stateSelectValue.value : "",
        city: this.state.cityValue,
        zipCode: this.state.zipCode,
        sendPromotionsMails: this.state.iAgree,
        sendNewsletter: this.state.iAgree,
        isRewardMigration: false,
        noOfMovieVisits: this.state.movieVisitsCount,
        noOfCmxVisits: this.state.CMXVisitsCount,
        isForceUpdate: false,
      },
      exhibitorid: process.env.REACT_APP_EXHIBITORID,
      exhibitorclass: process.env.REACT_APP_EXHIBITORCLASS,
      dataversion: "en-US",
    })
      .then((response) => {
        // console.log(response.data);
        if (response.data.code == 500) {
          console.log(response.data.message, "Register failed");
          this.setState({
            commonErrorMsg: response.data.message,
            otp_pageModalSH: false,
            commonErrorPoupSH: true,
            loader: false,
          });
        } else {
          console.log(response.data, "Register success");
          this.setState({
            registerAPI: response.data,
            otp_pageModalSH: true,
            loader: false,
          });
        }
      })
      .catch((ex) => {
        console.log(ex);
        console.log(ex.error);
        this.setState({
          commonErrorMsg: ex.error,
          otp_pageModalSH: false,
          commonErrorPoupSH: true,
          loader: false,
        });
      });
  };

  withoutMMR_signupBtn = () => {
    this.setState({
      otp: "",
      loader: true,
    });

    const username = process.env.REACT_APP_USERNAME_CINEMA_APP;
    const password = process.env.REACT_APP_PASSWORD_CINEMA_APP;
    const token = this.state.loginAPI.accessToken;
    const headers = {
      Authorization: `Bearer ${token}`,
      dataversion: "en-US",
      exhibitorclass: process.env.REACT_APP_EXHIBITORCLASS,
      exhibitorid: process.env.REACT_APP_EXHIBITORID,
    };
    const bodyRequest = {
      firstname: this.state.firstname,
      lastname: this.state.lastname,
      email: this.state.signUpEmailValue,
      password: this.state.signInPasswordValue,
      mobile: this.state.signUpMobileValue.replace(/[- )(]/g, ""),
      dob:
        this.state.loginAPI.additionaldetails.dateOfBirth != null
        ? this.state.loginAPI.additionaldetails.dateOfBirth.split("/")[0] +
          "/" +
          this.state.loginAPI.additionaldetails.dateOfBirth.split("/")[1] +
          "/" +
          this.state.loginAPI.additionaldetails.dateOfBirth.split("/")[2]
        : this.state.ua_YearSelectValue.value + "-" + this.state.birth_API_Month + "-" + this.state.ua_DateSelectValue.value,
      type: "new",
      isdobupdate: true,
      additionaldetails: {
        city: this.state.cityValue,
        state: this.state.loginAPI != "" ? this.state.loginAPI.additionaldetails.state : "",
        homephoneno: this.state.loginAPI != '' ? this.state.loginAPI.additionaldetails && this.state.loginAPI.additionaldetails.homephoneno ? this.state.loginAPI.additionaldetails.homephoneno.replace(/[- )(]/g,'') : "" :'',
        gender: "",
        zipCode: this.state.zipCode,
        address1: this.state.address1,
        address2: this.state.address2,
        sendNewsletter: this.state.iAgree,
        anniversaryDate:
          this.state.an_dateSelectValue != null && this.state.an_API_Month != "" && this.state.an_yearSelectValue != null
          ? this.state.an_API_Month + "/" + this.state.an_dateSelectValue.value + "/" + this.state.an_yearSelectValue.value
          : this.state.loginAPI.additionaldetails.anniversaryDate != null
          ? this.state.loginAPI.additionaldetails.anniversaryDate.split("/")[0] +
            "/" +
            this.state.loginAPI.additionaldetails.anniversaryDate.split("/")[1] +
            "/" +
            this.state.loginAPI.additionaldetails.anniversaryDate.split("/")[2]
          : "",
        isRewardMigration: false,
        preferredLocation: this.state.getCinemaId,
        sendPromotionsMails: this.state.iAgree,
        existingMembershipId: "",
        noOfMovieVisits: this.state.movieVisitsCount,
        noOfCmxVisits: this.state.CMXVisitsCount,
      },
    };
    axios
      .put(process.env.REACT_APP_BASEURL + "/subscriber/v1/updatemembership", bodyRequest, { headers })
      .then((response) => {
        console.log(response.data, "Without MMR (updatemembership API)");
        if (response.data.code == 500) {
          console.log(response.data.message);
          this.setState({
            commonErrorMsg: response.data.message,
            commonErrorPoupSH: true,
            loader: false,
          });
        } else {
          this.setState({
            updateMemberShipAPI: response.data,
            congratsPopupSH: true,
            loader: false,
          });
          // history.push("/payment");
        }
      })
      .catch((ex) => {
        console.log(ex.response.data.message);
        this.setState({
          commonErrorMsg: ex.response.data.message,
          commonErrorPoupSH: true,
          loader: false,
        });
      });
  };

  withoutMMR_signupDisabled = () => {
    if (this.state.loginAPI != "") {
      if (this.state.loginAPI.additionaldetails.dateOfBirth != null && this.state.loginAPI.additionaldetails.zipcode != null) {
        // console.log('dateOfBirth not empty--&&--zipcode not empty');
        var disabled = false;
        if (
          this.state.firstname == "" ||
          this.state.lastname == "" ||
          this.state.signUpEmailValue == "" ||
          this.state.signUpMobileValue == "" ||
          this.state.mobileErrorMsg != "" ||
          this.state.iAccept == false ||
          // this.state.movieVisitsCount == 0 ||
          // this.state.CMXVisitsCount == 0 ||
          this.state.zipCode == ""
        ) {
          disabled = true;
        }
        return disabled;
      }
      if (this.state.loginAPI.additionaldetails.dateOfBirth == null && this.state.loginAPI.additionaldetails.zipcode != null) {
        // console.log('dateOfBirth empty--&&--zipcode not empty');
        var disabled = false;
        if (
          this.state.firstname == "" ||
          this.state.lastname == "" ||
          this.state.signUpEmailValue == "" ||
          this.state.signUpMobileValue == "" ||
          this.state.mobileErrorMsg != "" ||
          this.state.iAccept == false ||
          this.state.ua_birthMonthSelectValue == null ||
          this.state.ua_DateSelectValue == null ||
          this.state.ua_YearSelectValue == null ||
          // this.state.movieVisitsCount == 0 ||
          // this.state.CMXVisitsCount == 0 ||
          this.state.zipCode == ""
        ) {
          disabled = true;
        }
        return disabled;
      }
      if (this.state.loginAPI.additionaldetails.dateOfBirth != null && this.state.loginAPI.additionaldetails.zipcode == null) {
        // console.log('dateOfBirth not empty--&&--zipcode empty');
        var disabled = false;
        if (
          this.state.firstname == "" ||
          this.state.lastname == "" ||
          this.state.signUpEmailValue == "" ||
          this.state.signUpMobileValue == "" ||
          this.state.mobileErrorMsg != "" ||
          this.state.iAccept == false ||
          // this.state.movieVisitsCount == 0 ||
          // this.state.CMXVisitsCount == 0 ||
          this.state.zipCode == ""
        ) {
          disabled = true;
        }
        return disabled;
      }
      if (this.state.loginAPI.additionaldetails.dateOfBirth == null && this.state.loginAPI.additionaldetails.zipcode == null) {
        // console.log('dateOfBirth empty--&&--zipcode empty');
        var disabled = false;
        if (
          this.state.firstname == "" ||
          this.state.lastname == "" ||
          this.state.signUpEmailValue == "" ||
          this.state.signUpMobileValue == "" ||
          this.state.mobileErrorMsg != "" ||
          this.state.iAccept == false ||
          this.state.ua_birthMonthSelectValue == null ||
          this.state.ua_DateSelectValue == null ||
          this.state.ua_YearSelectValue == null ||
          // this.state.movieVisitsCount == 0 ||
          // this.state.CMXVisitsCount == 0 ||
          this.state.zipCode == ""
        ) {
          disabled = true;
        }
        return disabled;
      }
    }
  };

  loyaltySignUpBtnDisabled = () => {
    if (this.state.filterLoyaltyObj != "") {
      if (this.state.loginAPI == "") {
        // console.log('With out--login--Password show');
        var disabled = false;
        if (this.state.filterLoyaltyObj.dateOfBirth != "") {
          if (
            this.state.firstname == "" ||
            this.state.lastname == "" ||
            this.state.signUpEmailValue == "" ||
            this.state.signUpMobileValue == "" ||
            this.state.signUpPasswordValue == "" ||
            this.state.signUp_PasswordErrorMsgSH != "" ||
            this.state.signUpConfirmPasswordValue == "" ||
            this.state.signUp_ConfirmPasswordErrorMsgSH != "" ||
            this.state.mobileErrorMsg != "" ||
            this.state.zipCode == "" ||
            this.state.ua_cinemaSelectValue == null ||
            this.state.iAccept == false
            // this.state.movieVisitsCount == 0 ||
            // this.state.CMXVisitsCount == 0
          ) {
            disabled = true;
          }
        } else {
          if (
            this.state.firstname == "" ||
            this.state.lastname == "" ||
            this.state.signUpEmailValue == "" ||
            this.state.signUpMobileValue == "" ||
            this.state.mobileErrorMsg != "" ||
            this.state.signUpPasswordValue == "" ||
            this.state.signUp_PasswordErrorMsgSH != "" ||
            this.state.signUpConfirmPasswordValue == "" ||
            this.state.signUp_ConfirmPasswordErrorMsgSH != "" ||
            this.state.zipCode == "" ||
            this.state.ua_birthMonthSelectValue == null ||
            this.state.ua_DateSelectValue == null ||
            this.state.ua_YearSelectValue == null ||
            this.state.ua_cinemaSelectValue == null ||
            this.state.iAccept == false
            // this.state.movieVisitsCount == 0 ||
            // this.state.CMXVisitsCount == 0
          ) {
            disabled = true;
          }
        }
        return disabled;
      } else {
        // console.log('With--login--Password hide');
        var disabled = false;
        if (this.state.filterLoyaltyObj.dateOfBirth != "") {
          if (
            this.state.firstname == "" ||
            this.state.lastname == "" ||
            this.state.signUpEmailValue == "" ||
            this.state.signUpMobileValue == "" ||
            this.state.signUpPasswordValue == "" ||
            this.state.signUp_PasswordErrorMsgSH != "" ||
            this.state.signUpConfirmPasswordValue == "" ||
            this.state.signUp_ConfirmPasswordErrorMsgSH != "" ||
            this.state.mobileErrorMsg != "" ||
            this.state.zipCode == "" ||
            this.state.ua_cinemaSelectValue == null ||
            this.state.iAccept == false
            // this.state.movieVisitsCount == 0 ||
            // this.state.CMXVisitsCount == 0
          ) {
            disabled = true;
          }
        } else {
          if (
            this.state.firstname == "" ||
            this.state.lastname == "" ||
            this.state.signUpEmailValue == "" ||
            this.state.signUpMobileValue == "" ||
            this.state.mobileErrorMsg != "" ||
            this.state.zipCode == "" ||
            this.state.ua_birthMonthSelectValue == null ||
            this.state.ua_DateSelectValue == null ||
            this.state.ua_YearSelectValue == null ||
            this.state.ua_cinemaSelectValue == null ||
            this.state.iAccept == false
            // this.state.movieVisitsCount == 0 ||
            // this.state.CMXVisitsCount == 0
          ) {
            disabled = true;
          }
        }
        return disabled;
      }
    }
  };

  yearCalculationFun = () => {
    var currentYear = new Date().getFullYear();
    var array = [];
    for (var i = 0; i <= 90; i++) {
      var tempObj = new Object();
      var previousYear = currentYear - i;
      tempObj.value = previousYear;
      tempObj.label = previousYear;
      array.push(tempObj);
      // console.log(array);
      var sortYear = array.sort((a, b) => {
        return a.value - b.value;
      });
      this.setState({
        year_Calculation: sortYear,
      });
    }
  };

  commonError_outsideClick = () => {
    this.setState({ commonErrorPoupSH: true });
  };
  cError_closeBtn = () => {
    this.setState({ commonErrorPoupSH: false });
    // if(this.state.otpErrorFlag == true){
    //   this.setState({
    //     otp_pageModalSH: true,
    //     otp:'',
    //   })
    // }
    if (this.state.commonErrorMsg == "Please enter a valid OTP") {
      this.setState({
        otp_pageModalSH: true,
        otp: "",
      });
    } else if (this.state.commonErrorMsg == "The user already exists. Please try to login or register a new account.") {
      this.setState({
        otp_pageModalSH: false,
        otp: "",
      });
    } else if (this.state.commonErrorMsg == "OTP has been sent to your email id") {
      this.setState({
        otp_pageModalSH: true,
        otp: "",
      });
    }
  };

  loyaltyPopup_outsideClick = () => {
    this.setState({ loyaltyPopupSH: true });
  };

  congrats_outsideClick = () => {
    this.setState({ congratsPopupSH: true });
  };

  congratsOkBtn = () => {
    this.setState({ congratsPopupSH: false });
    history.push("/payment");
  };

  loyalty_closeBtn = () => {
    this.setState({
      loyaltyPopupSH: false,
      okBtnSH: false,
    });
  };

  otp_outsideModelClick = () => {
    this.setState({ otp_pageModalSH: true });
  };

  otp_closeBtn = () => {
    this.setState({ otp_pageModalSH: false });
  };

  otpOnChange = (otp) => {
    this.setState({
      otp: otp,
    });
  };

  notify_outsideClick = () => {
    this.setState({ notifyPopupSH: true });
  };

  notify_closeBtn = () => {
    this.setState({ notifyPopupSH: false });
    window.location.href = "/";
  };

  lockPopup_outsideClick = () => {
    this.setState({ lockPopupSH: true });
  };

  lockPopup_closeBtn = () => {
    this.setState({ lockPopupSH: false });
  };

  tncPrivacy_outsideClick = () => {
    this.setState({ tncPrivacyPopupSH: true });
  };

  tncPrivacy_closeBtn = () => {
    this.setState({ tncPrivacyPopupSH: false });
  };

  otp_submitBtn = () => {
    this.setState({
      otp_pageModalSH: false,
      otpErrorFlag: false,
      loader: true,
    });

    const headers = {
      Authorization: `Bearer ${this.state.registerAPI.accessToken}`,
      dataversion: "en-US",
      exhibitorclass: process.env.REACT_APP_EXHIBITORCLASS,
      exhibitorid: process.env.REACT_APP_EXHIBITORID,
    };
    const bodyRequest = {
      verificationcode: this.state.otp,
    };
    axios
      .put(process.env.REACT_APP_BASEURL + "/subscriber/v1/register/activate", bodyRequest, { headers })
      .then((response) => {
        // console.log(response.data, 'otp Success');
        this.setState({
          otpAPI: response.data,
          otpErrorFlag: false,
          congratsPopupSH: true,
          loader: false,
        });
        // history.push("/payment");
      })
      .catch((ex) => {
        console.log(ex.response.data.message);
        this.setState({
          commonErrorMsg: ex.response.data.message,
          commonErrorPoupSH: true,
          otpErrorFlag: true,
          loader: false,
        });
      });
  };

  otpSubmitDisabled = () => {
    var disabled = false;
    if (this.state.otp.length == 6) {
      disabled = true;
    }
    return disabled;
  };

  otp_resendBtn = () => {
    this.setState({
      loader: true,
    });
    const headers = {
      Authorization: `Bearer ${this.state.registerAPI.accessToken}`,
      dataversion: "en-US",
      exhibitorclass: process.env.REACT_APP_EXHIBITORCLASS,
      exhibitorid: process.env.REACT_APP_EXHIBITORID,
    };

    axios
      .put(process.env.REACT_APP_BASEURL + "/subscriber/v1/register/resendotp", "", { headers })
      .then((response) => {
        // console.log(response.data);
        this.setState({
          otpResendAPI: response.data,
          commonErrorMsg: response.data.email.reason,
          commonErrorPoupSH: true,
          otp_pageModalSH: false,
          loader: false,
        });
      })
      .catch((ex) => {
        console.log(ex.response.data.message);
        this.setState({
          commonErrorMsg: ex.response.data.message,
          commonErrorPoupSH: true,
          otp_pageModalSH: false,
          loader: false,
        });
      });
  };

  ChangeLoc_PopupClick = (e, getIndex, locData) => {
    console.log(locData.plan);
    console.log(locData.id);
    var getName = e.target.innerHTML;
    axios
      .get(locData.plan)
      .then((response) => {
        this.setState(
          {
            loc_planJson: response.data,
          },
          () => {
            this.setState(
              {
                changeLocationPlan: locData.plan,
                getRegionId: locData.regionid,
                create_locationID: locData.id,
              },
              () => {
                this.GetAllLocationsJson();
              }
            );
          }
        );
        if (this.state.planState_Store.type == "location") {
          console.log("location");
          this.setState({
            homeGetPlanJson: locData.plan,
          });
        } else if (this.state.planState_Store.type == "region") {
          // console.log('region')
          // this.setState({
          //   homeGetPlanJson: locData.plan
          // })
        }
      })
      .catch((ex) => {
        console.log(ex.response);
      });

    this.setState({
      plan_pageModalSH: false,
      CL_ModalSH: false,
      locPopupIndex: getIndex,
      loc_name: getName,
    });
  };

  GetAllTheatresJson = () => {
    axios
      .get(process.env.REACT_APP_ALLTHEATERSJSON)
      .then((response) => {
        this.setState({
          loc_planJson: response.data,
        });
      })
      .catch((ex) => {
        console.log(ex.response);
      });
  };

  GetAllTheatresLoadFun = () => {
    axios
      .get(process.env.REACT_APP_ALLTHEATERSJSON)
      .then((response) => {
        this.setState({
          plan_allTheatreJson: response.data,
        });
      })
      .catch((ex) => {
        console.log(ex.response);
      });
  };

  // GetAllLocationsJson = () => {
  //   axios.get(process.env.REACT_APP_REGIONSJSON).then((response) => {
  //     this.setState({
  //       plan_regionsJson: response.data
  //     }, () => {
  //       this.setState({
  //         allRegion_Firstplans: this.state.plan_regionsJson[1].plans,
  //       })
  //       // var locName = 'Brickell 10';
  //       var locName = this.state.searchInputValue;
  //       var filtered = this.state.plan_regionsJson.filter(({Theater}) => Theater.includes(locName));
  //       console.log(filtered);
  //       if(filtered.length > 0){
  //         this.setState({
  //           regionsPopupData: filtered,
  //           regionPlanData: filtered[this.state.CR_getIndex].plans,
  //           allLoc_Name: filtered[this.state.CR_getIndex].name,
  //           // allRegion_Firstplans: filtered[0].plans,
  //           // allRegion_Firstplans: filtered[1].plans,
  //           region_firstObj: [filtered[this.state.CR_getIndex]]
  //         }, () => {
  //           this.GetRegionFirstPlan();
  //         })
  //       }
  //     })
  //   })
  //   .catch((ex) => {
  //     console.log(ex.response);
  //   });
  // }

  GetAllLocationsJson = () => {
    axios
      .get(process.env.REACT_APP_REGIONSJSON)
      .then((response) => {
        this.setState(
          {
            plan_regionsJson: response.data,
          },
          () => {
            var array = [];
            this.state.plan_regionsJson
              .filter((data) => data.id == this.state.getRegionId)
              .map((filterRegionObj) =>
                // console.log(filterRegionObj)
                array.push(filterRegionObj)
              );
            console.log(array);
            if (array.length > 0) {
              this.setState(
                {
                  regionsPopupData: array,
                  allRegion_Firstplans: array[0].plans,
                  regionPlanData: array[0].plans,
                  allLoc_Name: array[0].name,
                  region_firstObj: [array[0]],
                },
                () => {
                  this.GetRegionFirstPlan();
                }
              );
            }
            if (this.state.planState_Store.type == "region") {
              console.log("region");
              this.setState({
                homeGetPlanJson: array[0].plans,
              });
            }
          }
        );
      })
      .catch((ex) => {
        console.log(ex.response);
      });
  };

  GetRegionFirstPlan = () => {
    var getRegionFirstPlan = this.state.allRegion_Firstplans;
    axios
      .get(getRegionFirstPlan)
      .then((response) => {
        // console.log(response.data, 'asdasd');
        this.setState({
          regionFirstPlan: response.data,
        });
      })
      .catch((ex) => {
        console.log(ex.response);
      });
  };

  Plan_CR_onChangeFun = (e, getIndex) => {
    var tempregion = this.state.regionsPopupData;
    // console.log(tempregion[getIndex].plans)
    var getPlanJson = tempregion[getIndex].plans;
    this.setState({
      regionPlanData: getPlanJson,
      CR_getIndex: getIndex,
      applyBtnDisabled: true,
    });
  };

  CR_applyDisabled = () => {
    var disabled = false;
    if (this.state.applyBtnDisabled) {
      disabled = true;
    } else {
      disabled = false;
    }
    return disabled;
  };

  RegionApplyBtn = () => {
    var getIndex = this.state.CR_getIndex;
    var getName = this.state.regionsPopupData[getIndex].name;
    axios
      .get(this.state.regionPlanData)
      .then((response) => {
        this.setState({
          loc_planJson: response.data,
          CR_applyJson: true,
          allLoc_Name: getName,
          region_firstObj: [this.state.regionsPopupData[getIndex]],
        });
      })
      .catch((ex) => {
        console.log(ex.response);
      });
    this.setState({
      plan_pageModalSH: false,
    });
  };

  plan_regionSeeThtreList = () => {
    this.setState({
      plan_pageModalSH: true,
      CL_ModalSH: false,
      CR_ModalSH: false,
      CR_TL_ModalSH: true,
      All_theatre_ModalSH: false,
      AnnualBenefits: false,
      MonthlyBenefits: false,
    });
    this.regionPopup_sortData();
  };

  plan_allTheatre_SeeThtreList = () => {
    this.setState({
      plan_pageModalSH: true,
      CL_ModalSH: false,
      CR_ModalSH: false,
      CR_TL_ModalSH: false,
      AnnualBenefits: false,
      MonthlyBenefits: false,
      All_theatre_ModalSH: true,
    });
  };

  viewAnnualBenefits = () => {
    this.setState({
      plan_pageModalSH: true,
      CL_ModalSH: false,
      CR_ModalSH: false,
      CR_TL_ModalSH: false,
      All_theatre_ModalSH: false,
      MonthlyBenefits: false,
      AnnualBenefits: true,
    });
  };

  viewMonthlyBenefits = () => {
    this.setState({
      plan_pageModalSH: true,
      CL_ModalSH: false,
      CR_ModalSH: false,
      CR_TL_ModalSH: false,
      All_theatre_ModalSH: false,
      AnnualBenefits: false,
      MonthlyBenefits: true,
    });
  };

  plan_continueCalling = (getState) => {
    // console.log(getState);
    var pushArray = [];
    var tempObj = new Object();
    tempObj.monThu = getState.monThu;
    tempObj.allday = getState.allday;
    tempObj.visits = getState.visits;
    tempObj.guests = getState.guests;
    tempObj.period = getState.period;
    tempObj.type = getState.type;
    pushArray.push(tempObj);
    // console.log(pushArray);
    this.setState(
      {
        billingGetPriceObj: pushArray,
      },
      () => {
        this.setState({
          planPrice: this.getPrice(
            this.state.billingGetPriceObj[0].monThu,
            this.state.billingGetPriceObj[0].allday,
            this.state.billingGetPriceObj[0].visits,
            this.state.billingGetPriceObj[0].guests,
            "annually",
            this.state.billingGetPriceObj[0].type
          ),
        });
      }
    );
    this.getCurrentPlanJSON(getState);
    console.log(this.state.homeGetPlanJson);
  };

  getCurrentPlanJSON = (getState) => {
    console.log(getState);
    var tempStore = this.state.homeGetPlanJson;
    axios
      .get(tempStore)
      .then((response) => {
        this.setState(
          {
            getCurrentPlanJson: response.data,
          },
          () => {
            this.setState({
              planId: this.getPlanID(getState.monThu, getState.allday, getState.visits, getState.guests, this.state.choosePlanName),
            });
          }
        );
      })
      .catch((ex) => {
        console.log(ex.response);
      });
  };

  getPlanJsonPlanPage = (getState) => {
    console.log(getState.type);
    this.setState({
      planState_Store: getState,
    });
    if (getState.type == "location") {
      if (this.state.changeLocationPlan == "") {
        this.setState({
          homeGetPlanJson: this.state.getHomePlanJosn,
        });
      } else {
        this.setState({
          homeGetPlanJson: this.state.changeLocationPlan,
        });
      }
    } else if (getState.type == "region") {
      this.setState({
        homeGetPlanJson: this.state.allRegion_Firstplans,
      });
    } else if (getState.type == "allTheatre") {
      this.setState({
        homeGetPlanJson: process.env.REACT_APP_ALLTHEATERSJSON,
      });
    }
  };

  getPlanID = (monThu, allday, visits, quests, period) => {
    var currentJson = this.state.getCurrentPlanJson;
    var newArray = currentJson.filter(function (el) {
      return el.monThu == monThu && el.allDay == allday && el.visits == visits && el.guests == quests && el.period.toLowerCase() == period;
    });
    // console.log(newArray[0].id);
    return newArray[0].id;
  };

  selectPlan = () => {
    var tempObj = this.state.billingGetPriceObj;
    if (tempObj[0].type == "allTheatre") {
      this.setState({
        step1_content: "All CMX Theatres",
      });
    } else if (tempObj[0].type == "region") {
      this.setState({
        step1_content: this.state.allLoc_Name,
      });
    } else if (tempObj[0].type == "location") {
      this.setState({
        step1_content: this.state.loc_name,
      });
    }
    this.setState(
      {
        planId: this.getPlanID(tempObj[0].monThu, tempObj[0].allday, tempObj[0].visits, tempObj[0].guests, this.state.choosePlanName),
        lockPopupSH: false,
      },
      () => {
        history.push("/useraccount");
      }
    );
  };

  monthlySelectPlan = () => {
    this.setState({
      lockPopupSH: true,
    });
  };

  choosePlans = (e, getPrice, getPlanName) => {
    console.log(getPrice, getPlanName, "get Plan price");
    this.setState({
      planPrice: getPrice,
      choosePlanName: getPlanName,
    });
    if (getPlanName == "annually") {
      this.setState({
        annually_ActiveClass: true,
        monthly_ActiveClass: false,
      });
    } else if (getPlanName == "monthly") {
      this.setState({
        annually_ActiveClass: false,
        monthly_ActiveClass: true,
      });
    }
  };

  mobFaqClick = () => {
    this.setState({
      mobileMenu_SH: false,
    });
  };

  forgotPassword = () => {
    this.setState({
      forgotSH: true,
      forgotEmailValue: "",
    });
  };

  forgotContineBtn = () => {
    this.setState({
      loader: true,
      signInEmailValue: "",
      signInPasswordValue: "",
    });

    API.callEndpoint("POST", "Basic", "", "/subscriber/v1/forgotpassword", {
      email: this.state.forgotEmailValue,
      dataversion: "en-US",
      exhibitorclass: process.env.REACT_APP_EXHIBITORCLASS,
      exhibitorid: process.env.REACT_APP_EXHIBITORID,
    })
      .then((response) => {
        // console.log(response.data);
        if (response.data.code == 200 || response.data.code == 500) {
          this.setState({
            commonErrorMsg: response.data.message,
            commonErrorPoupSH: true,
            forgotSH: false,
            loader: false,
          });
        }
      })
      .catch((ex) => {
        console.log(ex.error);
        this.setState({
          commonErrorMsg: ex.error,
          commonErrorPoupSH: true,
          loader: false,
        });
      });
  };

  TandC_componentClick = (e, getPage) => {
    console.log(getPage);
    if (getPage == "header") {
      this.setState({
        tc: [
          {
            header: true,
            useraccount: false,
            payment: false,
          },
        ],
        mobileMenu_SH: false,
      });
      history.push("/terms-conditions");
    } else if (getPage == "useraccount") {
      this.setState({
        tc: [
          {
            header: false,
            useraccount: true,
            payment: false,
          },
        ],
      });
      history.push("/terms-conditions");
    } else if (getPage == "payment") {
      this.setState({
        tc: [
          {
            header: false,
            useraccount: false,
            payment: true,
          },
        ],
      });
      history.push("/terms-conditions");
    }
  };

  tcHeaderClose = () => {
    window.location.href = "/";
  };

  tc_AcceptClick = () => {
    this.setState(
      {
        iAccept: !this.state.iAccept,
      },
      () => {
        if (this.state.iAccept == false) {
          this.setState({
            tcErrorMsg: "Please agree the Terms and Condition.",
          });
        } else {
          this.setState({
            tcErrorMsg: "",
          });
        }
      }
    );
  };

  stateClear_formFields = () => {
    this.setState({
      firstname: "",
      lastname: "",
      signUpEmailValue: "",
      signUpMobileValue: "",
      signUpPasswordValue: "",
      signUpConfirmPasswordValue: "",
      signUpHomeMobileValue: "",
      address1: "",
      address2: "",
      cityValue: "",
      hpn_stateSelectValue: [],
      zipCode: "",
      ua_DateSelectValue: null,
      ua_birthMonthSelectValue: null,
      ua_YearSelectValue: null,
      ua_cinemaSelectValue: null,
      an_dateSelectValue: null,
      an_monthSelectValue: null,
      an_yearSelectValue: null,
      // loginAPI: []
    });
  };

  tc_AgreeClick = () => {
    this.setState({
      iAgree: !this.state.iAgree,
    });
  };

  signIn_emailOnchange = (e) => {
    const regexp = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    const eValue = e.target.value;
    const eName = e.target.name;
    if (regexp.test(eValue) == true) {
      // console.log("Email True");
      this.setState({
        signInCorrectEmailValue: true,
      });
    } else {
      // console.log("Email False");
      this.setState({
        signInCorrectEmailValue: false,
      });
    }
    this.setState({
      [eName]: eValue,
    });
  };

  signIn_emailOnblur = () => {
    if (this.state.signInCorrectEmailValue == false) {
      this.setState({
        signInEmailErrorMsg: "Please enter the email address.",
      });
    } else {
      this.setState({
        signInEmailErrorMsg: "",
      });
    }
  };

  signIn_passwordOnchange = (e) => {
    const eValue = e.target.value;
    const eName = e.target.name;
    this.setState({
      [eName]: eValue,
    });
  };

  signIn_passwordOnblur = () => {
    if (this.state.signInPasswordValue == "") {
      this.setState({
        signInPasswordErrorMsg: "Please enter the password.",
      });
    } else {
      this.setState({
        signInPasswordErrorMsg: "",
      });
    }
  };

  loginBtnDisabled = () => {
    var disabled = false;
    if (this.state.signInEmailValue == "" || this.state.signInCorrectEmailValue == false || this.state.signInPasswordValue == "") {
      disabled = true;
    }
    return disabled;
  };

  loginBtnClick = () => {
    this.setState({
      loader: true,
    });
    const username = this.state.signInEmailValue;
    const password = this.state.signInPasswordValue;
    const token = Buffer.from(`${username}:${password}`, "utf8").toString("base64");
    const headers = {
      Authorization: `Basic ${token}`,
      dataversion: "en-US",
      exhibitorclass: process.env.REACT_APP_EXHIBITORCLASS,
      exhibitorid: process.env.REACT_APP_EXHIBITORID,
    };
    const bodyRequest = {
      accessTokenExpiry: "1200",
      getUserInfo: true,
      keepMeSignedIn: false,
    };
    axios
      .post(process.env.REACT_APP_BASEURL + "/subscriber/v1/login", bodyRequest, { headers })
      .then((response) => {
        // console.log(response.data);
        this.setState(
          {
            loginAPI: response.data,
            loader: false,
          },
          () => {
            var temploginAPI = this.state.loginAPI;
            if (temploginAPI.memberid != null) {
              console.log("MMR user login");
              history.push("/payment");
              this.setState({
                memberIDTabsSH: false,
                memberIDReadOnly: false,
                withOut_MMRBtnTCSH: false,
              });
            } else {
              console.log("Without MMR user login");
              // Mobile number > convet
              var x = temploginAPI.phonenumber.replace(/\D/g, "").match(/(\d{0,3})(\d{0,3})(\d{0,4})/);
              var mobileNumberConvet = (temploginAPI.phonenumber = !x[2] ? x[1] : "(" + x[1] + ") " + x[2] + (x[3] ? "-" + x[3] : ""));

              // Home mobile number > convet
              var homeMobileNumberConvet;
              if (temploginAPI.additionaldetails.homephoneno != null) {
                var x = temploginAPI.additionaldetails.homephoneno.replace(/\D/g, "").match(/(\d{0,3})(\d{0,3})(\d{0,4})/);
                homeMobileNumberConvet = temploginAPI.additionaldetails.homephoneno = !x[2] ? x[1] : "(" + x[1] + ") " + x[2] + (x[3] ? "-" + x[3] : "");
              } else {
                homeMobileNumberConvet = "";
              }

              this.setState({
                memberIDTabsSH: true,
                memberIDReadOnly: true,
                withOut_MMRBtnTCSH: true,
                register_BtnTCSH: false,
                firstname: temploginAPI.firstname,
                lastname: temploginAPI.lastname,
                signUpEmailValue: temploginAPI.email,
                signUpMobileValue: mobileNumberConvet,
                // signUpHomeMobileValue: temploginAPI.additionaldetails.homephoneno != null ? temploginAPI.additionaldetails.homephoneno:'',
                signUpHomeMobileValue: homeMobileNumberConvet,
                address1: temploginAPI.additionaldetails.address != null ? temploginAPI.additionaldetails.address : "",
                address2: temploginAPI.additionaldetails.address1 != null ? temploginAPI.additionaldetails.address1 : "",
                cityValue: temploginAPI.additionaldetails.city != null ? temploginAPI.additionaldetails.city : "",
                zipCode: temploginAPI.additionaldetails.zipcode != null ? temploginAPI.additionaldetails.zipcode : "",
              });

              var getPL = temploginAPI.additionaldetails.preferredlocation;
              {
                this.state.signup_cinemaLocation
                  .filter((PLName) => PLName.cinemaid == getPL)
                  .map((filteredPerson) =>
                    // console.log(filteredPerson.name)
                    this.setState({
                      // withOut_PLName: filteredPerson.name,
                      withOut_PLName: filteredPerson.cinemas_attributes[0].name + " - " + filteredPerson.cinemas_locations[0].city,
                      getCinemaId: filteredPerson.cinemaid,
                    })
                  );
              }

              // Terms and Conditions
              if (temploginAPI.additionaldetails.agreetermscondition == false) {
                this.setState({
                  iAccept: false,
                });
              } else if (temploginAPI.additionaldetails.sendpromotionsmails == true) {
                this.setState({
                  iAgree: true,
                });
              }
            }
          }
        );
      })
      .catch((ex) => {
        console.log(ex.response.data.message);
        this.setState({
          commonErrorMsg: ex.response.data.message,
          commonErrorPoupSH: true,
          loader: false,
        });
      });
  };

  loginTab = () => {
    this.setState({
      memberIDTabsSH: false,
      signInEmailValue: "",
      signInPasswordValue: "",
      checkBtnActive: false,
      signUpPasswordValue: "",
      LltyMoleEmail_Value: "",
      check_PD_ComponentSH: false,
    });
    this.stateClear_formFields();
  };

  signUpTab = () => {
    this.setState({
      signUpPasswordValue: "",
    });
    this.stateClear_formFields();
  };

  forgot_emailOnchange = (e) => {
    const regexp = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    const eValue = e.target.value;
    const eName = e.target.name;
    if (regexp.test(eValue) == true) {
      // console.log("Email True");
      this.setState({
        forgotCorrectEmailValue: true,
      });
    } else {
      // console.log("Email False");
      this.setState({
        forgotCorrectEmailValue: false,
      });
    }
    this.setState({
      [eName]: eValue,
    });
  };

  forgot_emailOnblur = () => {
    if (this.state.forgotCorrectEmailValue == false) {
      this.setState({
        forgotEmailErrorMsg: "Please enter the email address.",
      });
    } else {
      this.setState({
        forgotEmailErrorMsg: "",
      });
    }
  };

  forgotContinueDisable = () => {
    var disabled = false;
    if (this.state.forgotCorrectEmailValue == false || this.state.forgotEmailValue == "") {
      disabled = true;
    }
    return disabled;
  };

  NameOnChange = (e) => {
    const getName = e.target.name;
    let value = e.target.value;
    value = value.replace(/[^A-Za-z ]/gi, "");
    this.setState({
      [getName]: value,
    });
  };

  fnOnblur = () => {
    if (this.state.firstname == "") {
      this.setState({
        fnErrorMsg: "Please enter the first name.",
      });
    } else {
      this.setState({
        fnErrorMsg: "",
      });
    }
  };

  lnOnblur = () => {
    if (this.state.lastname == "") {
      this.setState({
        lnErrorMsg: "Please enter the last name.",
      });
    } else {
      this.setState({
        lnErrorMsg: "",
      });
    }
  };

  signUp_emailOnchange = (e) => {
    const regexp = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    const eValue = e.target.value;
    const eName = e.target.name;
    if (regexp.test(eValue) == true) {
      // console.log("Email True");
      this.setState({
        signUpCorrectEmailValue: true,
      });
    } else {
      // console.log("Email False");
      this.setState({
        signUpCorrectEmailValue: false,
      });
    }
    this.setState({
      [eName]: eValue,
    });
  };

  signUp_emailOnblur = () => {
    if (this.state.signUpCorrectEmailValue == false) {
      this.setState({
        emailErrorMsg: "Please enter the email.",
      });
    } else {
      this.setState({
        emailErrorMsg: "",
      });
    }
  };

  signUp_PasswordOnchangeFun = (e) => {
    const getName = e.target.name;
    const getValue = e.target.value.replace("/", "").replace(":", "");
    this.setState({
      [getName]: getValue,
    });

    if (getValue.length >= 8) {
      // console.log(getValue.length, 'Password length');
      const strongRegex = new RegExp("(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#$%^&*])");
      if (strongRegex.test(e.target.value)) {
        this.setState({
          signUpPasswordValidation: true,
          signUp_PasswordErrorMsgSH: "",
        });
        // console.log('> = 8 if');
      } else {
        this.setState({
          signUpPasswordValidation: false,
        });
        // console.log('> = 8 else');
      }
    } else {
      this.setState({
        signUpPasswordValidation: false,
      });
      // console.log('else');
    }
  };

  signUp_ConfirmPasswordOnchangeFun = (e) => {
    const getName = e.target.name;
    const getValue = e.target.value.replace("/", "").replace(":", "");
    this.setState({
      [getName]: getValue,
    });

    if (getValue.length >= 8) {
      // console.log(getValue.length, 'Password length');
      const strongRegex = new RegExp("(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#$%^&*])");
      if (strongRegex.test(e.target.value)) {
        this.setState({
          signUpConfirmPasswordValidation: true,
          signUp_ConfirmPasswordErrorMsgSH: "",
        });
        // console.log('> = 8 if');
      } else {
        this.setState({
          signUpConfirmPasswordValidation: false,
        });
        // console.log('> = 8 else');
      }
    } else {
      this.setState({
        signUpConfirmPasswordValidation: false,
      });
      // console.log('else');
    }
  };

  signUp_ConfirmPasswordPolicyBlur = () => {
    if (this.state.signUpConfirmPasswordValue == "") {
      this.setState({
        signUp_ConfirmPasswordErrorMsgSH: "Please enter the confirm password.",
      });
    } else {
      // this.setState({
      //   signUp_ConfirmPasswordErrorMsgSH: "Please refer the password policy.",
      // });
      if (this.state.signUpPasswordValue != this.state.signUpConfirmPasswordValue) {
        console.log("The password does not match.");
        this.setState({
          signUp_ConfirmPasswordErrorMsgSH: "The password does not match.",
        });
      } else {
        console.log("The password match.");
        this.setState({
          signUp_ConfirmPasswordErrorMsgSH: "",
        });
      }
    }
  };

  ua_addressOnchange = (e) => {
    const getName = e.target.name;
    const getValue = e.target.value;
    this.setState({
      [getName]: getValue,
    });
  };

  ua_zipCodeOnchange = (e) => {
    var getName = e.target.name;
    var getValue = e.target.value;
    // if (!/[a-zA-Z0-9]+/g.test(getValue)) {
    //   e.target.value = e.target.value.replace(/\D/g, "");
    //   this.setState({
    //     zipCode: "",
    //   });
    // } else {
    //   this.setState({
    //     [getName]: getValue,
    //   });
    // }
    this.setState({
      [getName]: getValue.replace(/\s/g, ''),
    });
  };

  ua_zipCodeOnBlur = () => {
    // if (this.state.zipCode == "") {
    //   this.setState({
    //     zipErrorMsg: "Please enter the zip code.",
    //   });
    // } else {
    //   this.setState({
    //     zipErrorMsg: "",
    //   });
    // }
    var zipErrorMessage = ""
    let stateZipcode = this.state.zipCode;
    if (stateZipcode == "" || stateZipcode == null) {
      zipErrorMessage = "Please enter the zip code."
    } else if (stateZipcode.length < 5  || stateZipcode.length > 6) {
      zipErrorMessage = "Zip code should be minimum 5 and maximum 6 digits."
    } else if (stateZipcode.length == 5) {
      let strRegex = new RegExp(/^\d+$/);
      let strResult = strRegex.test(stateZipcode);
      if (strResult==false) {
        zipErrorMessage = "Zip code should be numeric."
      }
    } else if (stateZipcode.length == 6) {
      let strRegex = new RegExp(/^\d+$/);
      let strResult = strRegex.test(stateZipcode);
      // Alpha
      let alphaRegex = new RegExp(/^[a-zA-Z]+$/);
      let alphaResult = alphaRegex.test(stateZipcode);
      if(alphaResult==false) {
        if(strResult) {
          zipErrorMessage = "Zip code should be alphanumeric."
        }
      } else {
        zipErrorMessage = "Zip code should be alphanumeric."
      }
    }

    this.setState({
      zipErrorMsg: zipErrorMessage
    })
  };

  signUp_mobileOnchangeFun = (e) => {
    var x = e.target.value.replace(/\D/g, "").match(/(\d{0,3})(\d{0,3})(\d{0,4})/);
    e.target.value = !x[2] ? x[1] : "(" + x[1] + ") " + x[2] + (x[3] ? "-" + x[3] : "");
    var getValue = e.target.value;
    var getName = e.target.name;
    // console.log(getValue)
    this.setState({
      [getName]: getValue,
    });
  };

  signUp_mobileBlur = (event) => {
    let valueLength = event.target.value.length;
    // console.log(valueLength);
    if (this.state.signUpMobileValue == "") {
      this.setState({
        mobileErrorMsg: "Please enter the mobile number.",
      });
    } else {
      // this.setState({
      //   mobileErrorMsg: "",
      // });
      if (valueLength < 14) {
        this.setState({
          mobileErrorMsg: "Please enter the 10 digits mobile number.",
          signUp_Mobile10Digits: true,
        });
      } else if (valueLength == 14) {
        this.setState({
          mobileErrorMsg: "",
          signUp_Mobile10Digits: false,
        });
      }
    }
  };

  signupBtnDisabled = () => {
    var disabled = false;
    if (
      this.state.firstname == "" ||
      this.state.lastname == "" ||
      this.state.signUpEmailValue == "" ||
      this.state.signUpCorrectEmailValue == false ||
      this.state.signUpPasswordValue == "" ||
      this.state.signUp_PasswordErrorMsgSH != "" ||
      this.state.signUpConfirmPasswordValue == "" ||
      this.state.signUp_ConfirmPasswordErrorMsgSH != "" ||
      this.state.signUpMobileValue == "" ||
      this.state.signUp_Mobile10Digits == true ||
      this.state.zipCode == "" ||
      this.state.ua_birthMonthSelectValue == null ||
      this.state.ua_DateSelectValue == null ||
      this.state.ua_YearSelectValue == null ||
      // this.state.an_monthSelectValue == null ||
      // this.state.an_dateSelectValue == null ||
      // this.state.an_yearSelectValue == null ||
      this.state.ua_cinemaSelectValue == null ||
      this.state.iAccept == false
      // this.state.movieVisitsCount == 0 ||
      // this.state.CMXVisitsCount == 0
    ) {
      disabled = true;
    }
    return disabled;
  };

  loyaltyOnchange = (e, tabIndex) => {
    console.log(tabIndex);
    if (tabIndex == -1 || tabIndex == 0) {
      // console.log('Loyalty Number');
      var getValue = e.target.value;
      var getName = e.target.name;
      if (/\D/g.test(getValue)) {
        getValue = getValue.replace(/\D/g, "");
      }
      this.setState({
        [getName]: getValue,
      });
    } else if (tabIndex == 1) {
      // console.log('Mobile Number');
      var x = e.target.value.replace(/\D/g, "").match(/(\d{0,3})(\d{0,3})(\d{0,4})/);
      e.target.value = !x[2] ? x[1] : "(" + x[1] + ") " + x[2] + (x[3] ? "-" + x[3] : "");
      var getValue = e.target.value;
      var getName = e.target.name;
      this.setState({
        [getName]: getValue,
      });
    } else if (tabIndex == 2) {
      // console.log('Email ID');
      const regexp = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      const eValue = e.target.value;
      const eName = e.target.name;
      if (regexp.test(eValue) == true) {
        // console.log("Email True");
        this.setState({
          loyaltyCorrectEmailValue: true,
        });
      } else {
        // console.log("Email False");
        this.setState({
          loyaltyCorrectEmailValue: false,
        });
      }
      this.setState({
        [eName]: eValue,
      });
    }
  };

  loyltyOnblur = (e, tabIndex) => {
    if (tabIndex == -1 || tabIndex == 0) {
      // console.log('Loyalty Number onblur');
      if (this.state.LltyMoleEmail_Value != "") {
        console.log(this.state.LltyMoleEmail_Value.length);
        var rewrdNumLen = this.state.LltyMoleEmail_Value.length;
        if (rewrdNumLen == 7 || rewrdNumLen == 8 || rewrdNumLen == 9 || rewrdNumLen == 12 || rewrdNumLen == 14 || rewrdNumLen == 16) {
          this.setState({
            loyltyErrorMsg: "",
          });
        } else {
          this.setState({
            loyltyErrorMsg: "Please enter a valid Loyalty Number",
          });
        }
      } else {
        this.setState({
          loyltyErrorMsg: "Please enter the Loyalty Number",
        });
      }
    } else if (tabIndex == 1) {
      // console.log('Mobile Number onblur');
      let valueLength = e.target.value.length;
      console.log(valueLength);
      if (this.state.LltyMoleEmail_Value == "") {
        this.setState({
          loyltyErrorMsg: "Please enter the mobile number.",
        });
      } else {
        if (valueLength < 14) {
          this.setState({
            loyltyErrorMsg: "Please enter the 10 digits mobile number.",
            loylty_Mobile10Digits: true,
          });
        } else if (valueLength == 14) {
          this.setState({
            loyltyErrorMsg: "",
            loylty_Mobile10Digits: false,
          });
        }
      }
    } else if (tabIndex == 2) {
      // console.log('Email ID onblur');
      if (this.state.loyaltyCorrectEmailValue == false) {
        this.setState({
          loyltyErrorMsg: "Please enter the email.",
        });
      } else {
        this.setState({
          loyltyErrorMsg: "",
        });
      }
    }
  };

  loyaltyCheckDisabled = () => {
    var disabled = false;
    if (this.state.ua_rewardsTabIndex == -1 || this.state.ua_rewardsTabIndex == 0) {
      // console.log('Loyalty number');
      if (this.state.LltyMoleEmail_Value == "" || this.state.loyltyErrorMsg != "") {
        disabled = true;
      }
    } else if (this.state.ua_rewardsTabIndex == 1) {
      // console.log('Mobile number');
      if (this.state.LltyMoleEmail_Value == "" || this.state.loylty_Mobile10Digits == true) {
        disabled = true;
      }
    } else if (this.state.ua_rewardsTabIndex == 2) {
      // console.log('Email ID');
      if (this.state.LltyMoleEmail_Value == "" || this.state.loyaltyCorrectEmailValue == false) {
        disabled = true;
      }
    }
    return disabled;
  };

  loyaltyCheckBtn = () => {
    this.setState({
      // check_PD_ComponentSH: true,
      filterLoyaltyObj: [],
      loader: true,
    });
    if (this.state.ua_rewardsTabIndex == -1 || this.state.ua_rewardsTabIndex == 0) {
      console.log("Loyalty number API");
      const username = process.env.REACT_APP_USERNAME_CINEMA_APP;
      const password = process.env.REACT_APP_PASSWORD_CINEMA_APP;
      const token = Buffer.from(`${username}:${password}`, "utf8").toString("base64");
      const headers = {
        Authorization: `Basic ${token}`,
        dataversion: "en-US",
        exhibitorclass: process.env.REACT_APP_EXHIBITORCLASS,
        exhibitorid: process.env.REACT_APP_EXHIBITORID,
      };
      axios
        .get(process.env.REACT_APP_BASEURL + `/subscriber/v1/memberships?membershipId=${this.state.LltyMoleEmail_Value}&cardType=${this.state.loyalty_CardType}`, { headers })
        .then((response) => {
          console.log(response.data, "loyalty---API");
          this.setState({
            loyaltyAPI: response.data,
            loyaltyPopupSH: true,
            loader: false,
          });
        })
        .catch((ex) => {
          console.log(ex.response.data.message);
          this.setState({
            commonErrorMsg: ex.response.data.message,
            commonErrorPoupSH: true,
            loyaltyPopupSH: false,
            check_PD_ComponentSH: false,
            loader: false,
          });
          this.stateClear_formFields();
        });
    } else if (this.state.ua_rewardsTabIndex == 1) {
      console.log("Mobile number API");
      const username = process.env.REACT_APP_USERNAME_CINEMA_APP;
      const password = process.env.REACT_APP_PASSWORD_CINEMA_APP;
      const token = Buffer.from(`${username}:${password}`, "utf8").toString("base64");
      const headers = {
        Authorization: `Basic ${token}`,
        dataversion: "en-US",
        exhibitorclass: process.env.REACT_APP_EXHIBITORCLASS,
        exhibitorid: process.env.REACT_APP_EXHIBITORID,
      };
      axios
        .get(process.env.REACT_APP_BASEURL + `/subscriber/v1/memberships?phoneNumber=${this.state.LltyMoleEmail_Value}`, { headers })
        .then((response) => {
          console.log(response.data, "phoneNumber---API");
          this.setState({
            loyaltyAPI: response.data,
            loyaltyPopupSH: true,
            loader: false,
          });
        })
        .catch((ex) => {
          console.log(ex.response.data.message);
          this.setState({
            commonErrorMsg: ex.response.data.message,
            commonErrorPoupSH: true,
            loyaltyPopupSH: false,
            check_PD_ComponentSH: false,
            loader: false,
          });
          this.stateClear_formFields();
        });
    } else if (this.state.ua_rewardsTabIndex == 2) {
      console.log("Email ID");
      const username = process.env.REACT_APP_USERNAME_CINEMA_APP;
      const password = process.env.REACT_APP_PASSWORD_CINEMA_APP;
      const token = Buffer.from(`${username}:${password}`, "utf8").toString("base64");
      const headers = {
        Authorization: `Basic ${token}`,
        dataversion: "en-US",
        exhibitorclass: process.env.REACT_APP_EXHIBITORCLASS,
        exhibitorid: process.env.REACT_APP_EXHIBITORID,
      };
      axios
        .get(process.env.REACT_APP_BASEURL + `/subscriber/v1/memberships?email=${this.state.LltyMoleEmail_Value}`, { headers })
        .then((response) => {
          console.log(response.data, "email---API");
          this.setState({
            loyaltyAPI: response.data,
            loyaltyPopupSH: true,
            loader: false,
          });
        })
        .catch((ex) => {
          console.log(ex.response.data.message);
          this.setState({
            commonErrorMsg: ex.response.data.message,
            commonErrorPoupSH: true,
            loyaltyPopupSH: false,
            check_PD_ComponentSH: false,
            loader: false,
          });
          this.stateClear_formFields();
        });
    }
  };

  cardTypeOnChange = (e, cardData) => {
    this.setState({
      loyalty_CardType: cardData.cardType,
      ua_birthMonthSelectValue: null,
      ua_DateSelectValue: null,
      ua_YearSelectValue: null,
      ua_cinemaSelectValue: null,
      an_monthSelectValue: null,
      an_dateSelectValue: null,
      an_yearSelectValue: null,
    });
  };

  loyaltyPopupOnchange = (e, getIndex, loyaltyData) => {
    // console.log(getIndex, loyaltyData, loyaltyData.membershipId)
    this.setState({
      loyaltyPopupIndex: getIndex,
      loyaltyNumber: loyaltyData.membershipId,
      okBtnSH: true,
    });
  };

  loyaltyOkBtn = () => {
    this.setState({
      loyaltyPopupSH: false,
      okBtnSH: false,
      checkBtnActive: true,
    });
    {
      this.state.loyaltyAPI.data
        .filter((APIData) => APIData.membershipId == this.state.loyaltyNumber)
        .map((filteredCurrentObj) =>
          // console.log(filteredCurrentObj)
          this.setState(
            {
              filterLoyaltyObj: filteredCurrentObj,
              check_PD_ComponentSH: true,
              loyaltyMemberIDReadOnly: true,
            },
            () => {
              var tempObj = this.state.filterLoyaltyObj;
              // mobile number
              var MobileNumberConvet;
              if (tempObj.phoneNumber != null) {
                var x = tempObj.phoneNumber.replace(/\D/g, "").match(/(\d{0,3})(\d{0,3})(\d{0,4})/);
                MobileNumberConvet = tempObj.phoneNumber = !x[2] ? x[1] : "(" + x[1] + ") " + x[2] + (x[3] ? "-" + x[3] : "");
              } else {
                MobileNumberConvet = "";
              }

              this.setState({
                firstname: tempObj.firstName != null ? tempObj.firstName : "",
                lastname: tempObj.lastName != null ? tempObj.lastName : "",
                // signUpEmailValue: tempObj.emailAddress != null ? tempObj.emailAddress:'',
                // signUpMobileValue: MobileNumberConvet,
                // address1: tempObj.address1 != null ? tempObj.address1:'',
                // address2: tempObj.address2 != null ? tempObj.address2:'',
                // zipCode: tempObj.postalCode != null ? tempObj.postalCode:'',
              });
            }
          )
        );
    }
  };

  loyaltySignUpBtnOnClick = () => {
    this.setState({
      loader: true,
    });
    if (this.state.loginAPI != "" && this.state.loginAPI.memberid == null) {
      console.log("Login--without MMR ---- updatemembership API(I am a club tabs)");
      const token = this.state.loginAPI.accessToken;
      const headers = {
        Authorization: `Bearer ${token}`,
        dataversion: "en-US",
        exhibitorclass: process.env.REACT_APP_EXHIBITORCLASS,
        exhibitorid: process.env.REACT_APP_EXHIBITORID,
      };
      const bodyRequest = {
        firstname: this.state.firstname,
        lastname: this.state.lastname,
        email: this.state.signUpEmailValue,
        password: this.state.signInPasswordValue,
        mobile: this.state.signUpMobileValue.replace(/[- )(]/g, ""),
        dob:
          this.state.filterLoyaltyObj.dateOfBirth != ""
          ? this.state.filterLoyaltyObj.dateOfBirth.split("/")[0] + "/" + this.state.filterLoyaltyObj.dateOfBirth.split("/")[1] + "/" + this.state.filterLoyaltyObj.dateOfBirth.split("/")[2]
          : this.state.birth_API_Month + "/" + this.state.ua_DateSelectValue.value + "/" + this.state.ua_YearSelectValue.value,
        type: "new",
        isdobupdate: true,
        additionaldetails: {
          homephoneno: this.state.signUpHomeMobileValue != "" ? this.state.signUpHomeMobileValue.replace(/[- )(]/g, "") : "",
          city: this.state.cityValue,
          state: this.state.filterLoyaltyObj != "" ? this.state.filterLoyaltyObj.stateProvince : this.state.ua_cinemaSelectValue.value,
          gender: "",
          zipCode: this.state.zipCode,
          address1: this.state.address1,
          address2: this.state.address2,
          sendNewsletter: this.state.iAgree,
          anniversaryDate:
            this.state.an_dateSelectValue != null && this.state.an_API_Month != "" && this.state.an_yearSelectValue != null
            ? this.state.an_API_Month + "/" + this.state.an_dateSelectValue.value + "/" + this.state.an_yearSelectValue.value
            : this.state.filterLoyaltyObj.anniversaryDate != ""
            ? this.state.filterLoyaltyObj.anniversaryDate.split("/")[0] +
              "/" +
              this.state.filterLoyaltyObj.anniversaryDate.split("/")[1] +
              "/" +
              this.state.filterLoyaltyObj.anniversaryDate.split("/")[2]
            : "",
          isRewardMigration: true,
          preferredLocation: this.state.getCinemaId,
          sendPromotionsMails: this.state.iAgree,
          existingMembershipId: this.state.loyaltyNumber,
          noOfMovieVisits: this.state.movieVisitsCount,
          noOfCmxVisits: this.state.CMXVisitsCount,
        },
      };
      axios
        .put(process.env.REACT_APP_BASEURL + "/subscriber/v1/updatemembership", bodyRequest, { headers })
        .then((response) => {
          console.log(response.data, "Without MMR (updatemembership API)");
          if (response.data.code == 500) {
            console.log(response.data.message);
            this.setState({
              commonErrorMsg: response.data.message,
              commonErrorPoupSH: true,
              loader: false,
            });
          } else {
            this.setState({
              updateMemberShipAPI: response.data,
              congratsPopupSH: true,
              loader: false,
            });
            // history.push("/payment");
          }
        })
        .catch((ex) => {
          console.log(ex.response.data.message);
          this.setState({
            commonErrorMsg: ex.response.data.message,
            commonErrorPoupSH: true,
            loader: false,
          });
        });
    } else {
      console.log("Without login--register API(I am a club tabs)");
      API.callEndpoint("POST", "Basic", "", "/subscriber/v1/register", {
        email: this.state.signUpEmailValue,
        password: this.state.signUpPasswordValue,
        firstname: this.state.firstname,
        lastname: this.state.lastname,
        type: "CINEMACUSTOMER",
        accountImage: "",
        mobile: this.state.signUpMobileValue.replace(/[- )(]/g, ""),
        // dob: this.state.ua_DateSelectValue.value+'-'+this.state.birth_API_Month+'-'+this.state.ua_YearSelectValue.value,
        dob:
          this.state.filterLoyaltyObj.dateOfBirth != ""
          ? this.state.filterLoyaltyObj.dateOfBirth.split("/")[0] + "/" + this.state.filterLoyaltyObj.dateOfBirth.split("/")[1] + "/" + this.state.filterLoyaltyObj.dateOfBirth.split("/")[2]
          : this.state.birth_API_Month + "/" + this.state.ua_DateSelectValue.value + "/" + this.state.ua_YearSelectValue.value,
        favLocations: [],
        favGenres: [],
        planname: "",
        additionaldetails: {
          homephoneno: this.state.signUpHomeMobileValue != "" ? this.state.signUpHomeMobileValue.replace(/[- )(]/g, "") : "",
          planname: "",
          anniversaryDate:
            this.state.an_dateSelectValue != null && this.state.an_API_Month != "" && this.state.an_yearSelectValue != null
            ? this.state.an_API_Month + "/" + this.state.an_dateSelectValue.value + "/" + this.state.an_yearSelectValue.value
            : this.state.filterLoyaltyObj.anniversaryDate != ""
            ? this.state.filterLoyaltyObj.anniversaryDate.split("/")[0] +
              "/" +
              this.state.filterLoyaltyObj.anniversaryDate.split("/")[1] +
              "/" +
              this.state.filterLoyaltyObj.anniversaryDate.split("/")[2]
            : "",
          preferredLocation: this.state.getCinemaId,
          existingMembershipId: this.state.loyaltyNumber,
          address1: this.state.address1,
          address2: this.state.address2,
          gender: "",
          // state: this.state.hpn_stateSelectValue != null ? this.state.hpn_stateSelectValue.value:'',
          state: this.state.filterLoyaltyObj != "" ? this.state.filterLoyaltyObj.stateProvince : this.state.hpn_stateSelectValue != null ? this.state.hpn_stateSelectValue.value : "",
          city: this.state.cityValue,
          zipCode: this.state.zipCode,
          sendPromotionsMails: this.state.iAgree,
          sendNewsletter: this.state.iAgree,
          isRewardMigration: true,
          noOfMovieVisits: this.state.movieVisitsCount,
          noOfCmxVisits: this.state.CMXVisitsCount,
          isForceUpdate: false,
        },
        exhibitorid: process.env.REACT_APP_EXHIBITORID,
        exhibitorclass: process.env.REACT_APP_EXHIBITORCLASS,
        dataversion: "en-US",
      })
        .then((response) => {
          // console.log(response.data);
          if (response.data.code == 500) {
            console.log(response.data.message, "Without login---Register failed");
            this.setState({
              commonErrorMsg: response.data.message,
              otp_pageModalSH: false,
              commonErrorPoupSH: true,
              loader: false,
            });
          } else {
            console.log(response.data, "Without login---Register success");
            this.setState({
              // registerAPI_withoutLogin: response.data,
              registerAPI: response.data,
              otp_pageModalSH: true,
              loader: false,
            });
          }
        })
        .catch((ex) => {
          console.log(ex.error);
          this.setState({
            commonErrorMsg: ex.error,
            otp_pageModalSH: false,
            commonErrorPoupSH: true,
            loader: false,
          });
        });
    }
  };

  nameOnCardOnChange = (e) => {
    let getName = e.target.name;
    this.setState({
      [getName]: e.target.value,
    });
  };

  payment_CreateAPI = () => {
    this.setState({
      loader: true,
    });
    const token = this.state.loginAPI != "" ? this.state.loginAPI.accessToken : this.state.otpAPI.accessToken;
    const headers = {
      Authorization: `Bearer ${token}`,
      appplatform: "WEBSITE",
      dataversion: "en-US",
      appversion: "1.0.0",
    };
    const bodyRequest = {
      email: this.state.loginAPI != "" ? this.state.loginAPI.email : this.state.otpAPI.email,
      planid: this.state.planId,
      exhibitorid: process.env.REACT_APP_EXHIBITORID,
      homecircuitid: process.env.REACT_APP_EXHIBITORID,
      loyaltyid: this.state.loginAPI == "" ? this.state.otpAPI.memberid : this.state.loginAPI.memberid == null ? this.state.updateMemberShipAPI.data.membershipId : this.state.loginAPI.memberid,
      locationid: this.state.getLocationId,
      statecode: this.state.getStateVal,
      additionalInfo: {
        primaryLocation: {
          id: this.state.getLocationId,
          label: this.state.create_locationName,
        },
        planLocation: {
          id: this.state.step1_id,
          label: this.state.step1_name,
          value: this.state.step1_value,
        },
        planDays: {
          label: this.state.step2_name,
          subLabel: this.state.step2_subname,
          value: this.state.step2_value,
        },
        visits: {
          label: this.state.step3_name,
          value: this.state.step3_value,
        },
        guest: {
          label: this.state.step4_name,
          value: this.state.step4_value,
        },
      },
    };
    axios
      // .post(process.env.REACT_APP_BASEURL + "/subscription/v1/subscriptions/create", bodyRequest, {headers})
      .post(process.env.REACT_APP_BASEURL + "/middleware/v1/api/subscription/create", bodyRequest, { headers })
      .then((response) => {
        console.log(response.data, "Create API");
        this.setState(
          {
            createAPI: response.data,
            loader: false,
          },
          () => {
            this.payment_InitAPI();
            this.taxDetailsAPI();
          }
        );
      })
      .catch((ex) => {
        console.log(ex.response.data.message);
        this.setState({
          commonErrorMsg: ex.response.data.message,
          commonErrorPoupSH: true,
          loader: false,
        });
        history.push("/useraccount");
      });
  };

  payment_InitAPI = () => {
    this.setState({
      loader: true,
    });
    const token = this.state.loginAPI != "" ? this.state.loginAPI.accessToken : this.state.otpAPI.accessToken;
    const headers = {
      Authorization: `Bearer ${token}`,
      appplatform: "WEBSITE",
      dataversion: "en-US",
      appversion: "1.0.0",
    };
    const bodyRequest = {
      subscriptionid: this.state.createAPI.id,
    };
    axios
      .post(process.env.REACT_APP_BASEURL + "/subscription/v1/checkout/payment/init", bodyRequest, { headers })
      .then((response) => {
        // console.log(response.data, 'Payment Init API');
        if (response.data.code == "000") {
          var splitSrc = response.data.iframe.split('src="');
          // var getSrc = splitSrc[1].split('">');
          var getSrc = splitSrc[1].split('"');
          // console.log(getSrc[0])
          var sessionKey = getSrc[0].split("sessionKey=");
          // console.log(sessionKey, "sessionKey");
          this.setState({
            paymentInitAPI: response.data,
            paymentIframeSrc: getSrc[0],
            paymentSessionKey: sessionKey[1],
            loader: false,
          });
        }
        if (response.data.code == "001") {
          this.setState({
            commonErrorMsg: response.data.message,
            commonErrorPoupSH: true,
            loader: false,
          });
        }
      })
      .catch((ex) => {
        console.log(ex.response.data.message);
        this.setState({
          commonErrorMsg: ex.response.data.message,
          commonErrorPoupSH: true,
          loader: false,
        });
      });
  };

  payment_PayAPI = () => {
    console.log("Pay button click");
    var self = this;
    self.setState({
      loader: true,
    });
    const token = this.state.loginAPI != "" ? this.state.loginAPI.accessToken : this.state.otpAPI.accessToken;
    const headers = {
      Authorization: `Bearer ${token}`,
      appplatform: "WEBSITE",
      dataversion: "en-US",
      appversion: "1.0.0",
    };
    const bodyRequest = {
      nameOnCard: self.paymentNameOnCard,
      subscriptionid: self.state.createAPI.id,
      paymentKey: self.state.paymentKeys,
      token: self.state.paymentSessionKey,
    };
    axios
      .post(process.env.REACT_APP_BASEURL + "/subscription/v1/checkout/pay", bodyRequest, { headers })
      .then((response) => {
        if (response.data.code == "200") {
          console.log(response.data, "Payment Success");
          self.setState({
            paymentPayAPI: response.data,
            loader: false,
          });
          history.push("/payment-success");
        } else {
          console.log(response.data.message, "Payment failed");
          self.setState({
            loader: false,
          });
          history.push("/payment-failure");
        }
      })
      .catch((ex) => {
        console.log(ex.response.data.message);
        self.setState({
          loader: false,
        });
        history.push("/payment-failure");
      });
  };

  addMessageListener = () => {
    window.addEventListener("message", this.handleMessage);
  };

  handleMessage = (e) => {
    var message = e.data,
      data = message.data;
    // console.log(e);
    // console.log(message);

    switch (message.type) {
      case 1:
        // handleErrors(data);
        break;
      case 2:
        // setFrameHeight(data);
        break;
      case 3:
        // submitPayment(data);
        // console.log(data.attributes[0].Value);
        // console.log(data.paymentKeys[0]);
        if (data.paymentKeys[0]) {
          this.setState(
            {
              paymentKeys: data.paymentKeys[0],
              paymentType: data.attributes[0].Value,
            },
            () => {
              this.payment_PayAPI();
            }
          );
        }
        break;
      case 4:
        break;
      case 15:
        this.handleLegalClick(data);
        break;
    }
  };

  handleLegalClick = (data) => {
    if (data.id == "terms") {
      console.log("terms");
      this.setState({
        tncPrivacyPopupSH: true,
        p_tandc: true,
        p_privacy: false,
      });
    }
    if (data.id == "privacy") {
      console.log("privacy");
      this.setState({
        tncPrivacyPopupSH: true,
        p_tandc: false,
        p_privacy: true,
      });
    }
  };

  mobileSignInBtn = () => {
    this.setState({
      mobileMenu_SH: false,
    });
    window.location.href = "/";
  };

  mobileRegisterNowBtn = () => {
    this.setState({
      mobileMenu_SH: false,
      memberIDTabsSH: true,
    });
    window.location.href = "/";
  };

  login_enterKey = (e) => {
    if (this.state.signInEmailValue != "" && this.state.signInPasswordValue != "") {
      if (e.key === "Enter") {
        this.loginBtnClick();
      }
    }
  };

  get_StateJson = () => {
    fetch("../data/states.json", {
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
    })
      .then((response) => response.json())
      .then((data) => {
        console.log(data, "get code");
        this.setState(
          {
            stateJson: data,
          },
          () => {
            var arrayPush = [];
            this.state.stateJson.map((cinemaData, index) => {
              var obj = new Object();
              obj.value = cinemaData.Code;
              obj.label = cinemaData.Code;
              arrayPush.push(obj);
              this.setState({
                stateJson: arrayPush,
              });
            });
          }
        );
      })
      .catch((ex) => {
        console.log(ex.error);
      });
  };

  taxDetailsAPI = () => {
    const token = this.state.loginAPI != "" ? this.state.loginAPI.accessToken : this.state.otpAPI.accessToken;
    const headers = {
      Authorization: `Bearer ${token}`,
      appplatform: "WEBSITE",
      appversion: "1.0.0",
      dataversion: "en-US",
    };
    axios
      .get(process.env.REACT_APP_BASEURL + `/exhibitors/v1/exhibitors/10002/taxdetails?cinemaid=${this.state.getLocationId}`, { headers })
      .then((response) => {
        // console.log(response.data);
        this.setState(
          {
            taxAPI: response.data,
          },
          () => {
            this.taxCalucation();
          }
        );
      })
      .catch((ex) => {
        console.log(ex.response.data.message);
        this.setState({
          commonErrorMsg: ex.response.data.message,
          commonErrorPoupSH: true,
        });
      });
  };

  taxCalucation = () => {
    if (this.state.taxAPI.length > 0) {
      var taxValue = (this.state.createAPI.priceBeforeTax * this.state.taxAPI[0].taxpercentage) / 100;
      var feeValue = this.state.createAPI.taxValue - taxValue;
      var taxMinue = 9 - Number(this.state.taxAPI[0].taxpercentage);
      var ninePer = Math.floor(taxMinue * 100) / 100;
      console.log(ninePer, "taxMinue");
      console.log(taxValue.toFixed(2), "tax");
      console.log(feeValue.toFixed(2), "Fees");
      var tax = taxValue.toFixed(2);
      var fee = feeValue.toFixed(2);

      // new corrected tax and fee value
      let taxNFee = this.state.createAPI.taxValue;

      let newFeeValue = taxNFee / (1 + 7 / 100);
      let newTaxValue = taxNFee - newFeeValue;

      let correctedFeeValue = newFeeValue.toFixed(2);
      let correctedTaxValue = newTaxValue.toFixed(2);

      this.setState({
        pay_TaxVal: tax,
        pay_FeeVal: fee,
        pay_FeeCal: ninePer,
        correctedFeeValue,
        correctedTaxValue,
      });
    }
  };

  notifySubmitBtn = () => {
    this.setState({
      loader: true,
    });
    API.callEndpoint("POST", "Basic", "", "/subscriber/v1/notify", {
      email: this.state.notifyEmailValue,
      exhibitorid: "10002",
      locations: 10108,
      planid: "",
      planname: "",
    })
      .then((response) => {
        this.setState({
          notifyAPI: response.data,
          notifyPopupSH: true,
          loader: false,
        });
      })
      .catch((ex) => {
        console.log(ex.error);
        this.setState({
          commonErrorMsg: ex.error,
          commonErrorPoupSH: true,
          loader: false,
        });
      });
  };

  forgot_loginClick = () => {
    this.setState({
      forgotSH: false,
      signInEmailValue: "",
      signInPasswordValue: "",
    });
  };

  faq_JsonData = () => {
    fetch("../data/faq.json", {
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
    })
      .then((response) => response.json())
      .then((data) => {
        console.log(data, "faq");
        this.setState({
          faqjson: data,
        });
      })
      .catch((ex) => {
        console.log(ex.error);
      });
  };

  updatePaymentNameOnCard = (e) => {
    let getName = e.target.name;
    this.setState({
      [getName]: e.target.value,
    });
  };

  regionPopup_sortData = () => {
    var regionArray = [];
    this.state.locationsJson.map((locNameData, index) => {
      this.state.region_firstObj.map((firstData, index) => {
        firstData.Theater.map((thteData, thIndex) => {
          if (locNameData.name == thteData) {
            // console.log(locNameData.state);
            // console.log(locNameData.city, 'getcity');
            regionArray.push(locNameData.state);
            var getUniqueState = regionArray.filter((item, index) => regionArray.indexOf(item) === index);
            // console.log(getUniqueState);
            this.setState({
              regionUniquePopup: getUniqueState.sort(),
            });
          }
        });
      });
    });
  };

  createAPI_additionalInfo = (getState) => {
    // step 1
    if (getState.type == "location") {
      let text = document.getElementById("location").textContent;
      this.setState({
        step1_id: this.state.create_locationID,
        step1_name: text,
        step1_value: this.getPrice(getState.monThu, getState.allday, getState.visits, getState.guests, getState.period, "location"),
      });
    } else if (getState.type == "region") {
      let text = document.getElementById("changeRegion").textContent;
      this.state.plan_regionsJson
        .filter((data) => data.id == this.state.getRegionId)
        .map((filterRegionObj) =>
          // console.log(filterRegionObj.id)
          this.setState({
            step1_id: filterRegionObj.id,
          })
        );
      this.setState({
        step1_name: text,
        step1_value: this.getPrice(getState.monThu, getState.allday, getState.visits, getState.guests, getState.period, "region"),
      });
    } else if (getState.type == "allTheatre") {
      let text = document.getElementById("allTheatres").textContent;
      axios
        .get(process.env.REACT_APP_ALLTHEATERSJSON)
        .then((response) => {
          this.setState(
            {
              createAPI_getID: response.data,
            },
            () => {
              var newArray = this.state.createAPI_getID.filter(function (el) {
                return el.monThu == getState.monThu && el.allDay == getState.allday && el.visits == getState.visits && el.guests == getState.guests && el.period.toLowerCase() == getState.period;
              });
              // console.log(newArray);
              this.setState({
                step1_id: newArray[0].id,
              });
            }
          );
        })
        .catch((ex) => {
          console.log(ex.response);
        });
      this.setState({
        step1_name: text,
        step1_value: this.getPrice(getState.monThu, getState.allday, getState.visits, getState.guests, getState.period, "allTheatre"),
      });
    }

    // step 2
    if (getState.monThu == true) {
      let text = document.getElementById("monThu").textContent;
      let subtext = document.getElementById("subMonThu").textContent;
      this.setState({
        step2_name: text,
        step2_subname: subtext,
        step2_value: this.getPrice(true, false, getState.visits, getState.guests, getState.period, getState.type),
      });
    } else if (getState.allday == true) {
      let text = document.getElementById("allday").textContent;
      let subtext = document.getElementById("subAllday").textContent;
      this.setState({
        step2_name: text,
        step2_subname: subtext,
        step2_value: this.getPrice(false, true, getState.visits, getState.guests, getState.period, getState.type),
      });
    }

    // step 3
    if (getState.visits == 1 || getState.visits == 2 || getState.visits == 3 || getState.visits == 4 || getState.visits == 5 || getState.visits == 6) {
      let text = document.getElementById(`visit${getState.visits}`).textContent;
      this.setState({
        step3_name: text,
        step3_value: this.getPrice(getState.monThu, getState.allday, getState.visits, getState.guests, getState.period, getState.type),
      });
    }

    // step 4
    if (getState.guests == 0 || getState.guests == 1 || getState.guests == 2 || getState.guests == 3 || getState.guests == 4 || getState.guests == 5) {
      let text = document.getElementById(`guest${getState.guests}`).textContent;
      this.setState({
        step4_name: text,
        step4_value: this.getPrice(getState.monThu, getState.allday, getState.visits, getState.guests, getState.period, getState.type),
      });
    }
  };

  successfullPage_numberToTextConvet = (num) => {
    var a = [
      "",
      "one ",
      "two ",
      "three ",
      "four ",
      "five ",
      "six ",
      "seven ",
      "eight ",
      "nine ",
      "ten ",
      "eleven ",
      "twelve ",
      "thirteen ",
      "fourteen ",
      "fifteen ",
      "sixteen ",
      "seventeen ",
      "eighteen ",
      "nineteen ",
    ];
    var b = ["", "", "twenty", "thirty", "forty", "fifty", "sixty", "seventy", "eighty", "ninety"];

    if ((num = num.toString()).length > 9) return "overflow";
    var n = ("000000000" + num).substr(-9).match(/^(\d{2})(\d{2})(\d{2})(\d{1})(\d{2})$/);
    if (!n) return;
    var str = "";
    str += n[1] != 0 ? (a[Number(n[1])] || b[n[1][0]] + " " + a[n[1][1]]) + "crore " : "";
    str += n[2] != 0 ? (a[Number(n[2])] || b[n[2][0]] + " " + a[n[2][1]]) + "lakh " : "";
    str += n[3] != 0 ? (a[Number(n[3])] || b[n[3][0]] + " " + a[n[3][1]]) + "thousand " : "";
    str += n[4] != 0 ? (a[Number(n[4])] || b[n[4][0]] + " " + a[n[4][1]]) + "hundred " : "";
    str += n[5] != 0 ? (str != "" ? "and " : "") + (a[Number(n[5])] || b[n[5][0]] + " " + a[n[5][1]]) : "";
    console.log(str);
    return str;
  };

  guideCloseBtn = () => {
    this.setState({
      headerC_SH: true,
    });
    history.push("/payment-success");
  };

  privacyClose = () => {
    this.setState({
      memberIDTabsSH: true,
    });
    history.push("/useraccount");
  };

  tandcClose = () => {
    this.setState({
      memberIDTabsSH: true,
    });
    history.push("/useraccount");
  };

  successHeaderHome = () => {
    let queryString = window.location.pathname;
    if (queryString == "/payment-success") {
      this.setState({
        header_homeSH: true,
      });
    } else {
      this.setState({
        header_homeSH: false,
      });
    }
  };

  CMXWebsiteLogin = () => {
    if (this.state.cmxWebsite_LoginQuery != undefined) {
      // var encryptedText = '+Ja5BrLvBOGdy2jOquD+nG74MiWAhcfF';
      // var encryptedText = this.state.cmxWebsite_LoginQuery.replace(" ", "+");
      var encryptedText = this.state.cmxWebsite_LoginQuery.split(" ").join("+");
      var key = this.state.cmxWebsite_key;
      key = CryptoJS.enc.Utf8.parse(key);
      key = CryptoJS.MD5(key);
      key.words.push(key.words[0], key.words[1]);
      var options = {
        mode: CryptoJS.mode.ECB,
        padding: CryptoJS.pad.Pkcs7,
      };
      var decrypted = CryptoJS.TripleDES.decrypt(
        {
          ciphertext: CryptoJS.enc.Base64.parse(encryptedText),
        },
        key,
        options
      );
      var getMailId = decrypted.toString(CryptoJS.enc.Utf8);
      console.log(decrypted.toString(CryptoJS.enc.Utf8));
      this.setState(
        {
          cmxWebsite_LoginMailId: getMailId,
          signInEmailValue: getMailId,
          signInCorrectEmailValue: true,
        },
        () => {
          history.push("/");
        }
      );
    }
  };

  CMXCinemalogo = () => {
    var getEmail = "";
    var getpsd = "";
    if (this.state.loginAPI != "") {
      getEmail = this.state.signInEmailValue;
      getpsd = this.state.signInPasswordValue;
    } else if (this.state.createAPI != "") {
      getEmail = this.state.signUpEmailValue;
      getpsd = this.state.signUpPasswordValue;
    }

    var key = this.state.cmxWebsite_key;
    key = CryptoJS.enc.Utf8.parse(key);
    key = CryptoJS.MD5(key);
    key.words.push(key.words[0], key.words[1]);
    var options = {
      mode: CryptoJS.mode.ECB,
    };
    var emailWordArray = CryptoJS.enc.Utf8.parse(getEmail);
    var emailencrypted = CryptoJS.TripleDES.encrypt(emailWordArray, key, options);
    var emailbase64String = emailencrypted.toString();

    var padWordArray = CryptoJS.enc.Utf8.parse(getpsd);
    var psdencrypted = CryptoJS.TripleDES.encrypt(padWordArray, key, options);
    var psdbase64String = psdencrypted.toString();
    // console.log('Encrypted: ' + emailbase64String, psdbase64String);

    var url;
    if (process.env.REACT_APP_WEBSITE == "dev") {
      // url = "http://cmxweb.influx.co.in";
      url = "https://cmxweb-a1v1.influx.co.in";
    } else {
      url = "https://www.cmxcinemas.com";
    }
    window.location.href = "" + url + "/extendedmicrosite?id=" + emailbase64String + "&pwd=" + psdbase64String + "";
  };

  settingsLoyaltyLocationsAPI = () => {
    this.setState({
      loader: true,
    });
    API.callEndpoint("GET", "Bearer", "", "/exhibitors/v1/exhibitors/10002/settings?type=subscriptionStatus", {})
    .then((response) => {
      // console.log(response.data, 'response');
      this.setState({
        homeSettingsAPI: response.data,
        loader: false
      }, () => {
        if(!this.state.homeSettingsAPI[0].configs.subscriptionEnabled){
          document.body.className = "enhancements-settings";
        }
      })
    })
    .catch((ex) => {
      console.log(ex.error);
      this.setState({
        loader: false
      })
    });
  }

  render() {
    return (
      <section className={`wrapper ${this.state.payment_overlay ? "open-overlay" : ""}`}>
        {this.state.loader && <Loader />}
        <Router history={history}>
          {this.state.headerC_SH && (
            <Header
              state={this.state}
              h_menu={this.h_menu}
              h_closeBtn={this.h_closeBtn}
              headerHeight={this.headerHeight}
              h_goHome={this.h_goHome}
              mobFaqClick={this.mobFaqClick}
              TandC_componentClick={this.TandC_componentClick}
              mobileSignInBtn={this.mobileSignInBtn}
              mobileRegisterNowBtn={this.mobileRegisterNowBtn}
              CMXCinemalogo={this.CMXCinemalogo}
            />
          )}
          <Switch>
            <Route exact path="/">
              <Home
                state={this.state}
                home_mobileClick={this.home_mobileClick}
                home_btmCloseBtn={this.home_btmCloseBtn}
                home_searchInputChange={this.home_searchInputChange}
                customPlan={this.customPlan}
                home_locationClick={this.home_locationClick}
                Home_NotifyMailOnChange={this.Home_NotifyMailOnChange}
                Home_NotifyOnblur={this.Home_NotifyOnblur}
                notifyBtnDisabled={this.notifyBtnDisabled}
                notifySubmitBtn={this.notifySubmitBtn}
                h_goHome={this.h_goHome}
              ></Home>
            </Route>
            <Route exact path="/plan">
              <Plan
                state={this.state}
                step2={this.step2}
                step3={this.step3}
                step4={this.step4}
                Plan_changeLocationModel={this.Plan_changeLocationModel}
                Plan_changeRegion={this.Plan_changeRegion}
                plan_onChangeFun={this.plan_onChangeFun}
                getPrice={this.getPrice}
                GetAllTheatresJson={this.GetAllTheatresJson}
                plan_regionSeeThtreList={this.plan_regionSeeThtreList}
                plan_continueCalling={this.plan_continueCalling}
                plan_allTheatre_SeeThtreList={this.plan_allTheatre_SeeThtreList}
                getPlanJsonPlanPage={this.getPlanJsonPlanPage}
                createAPI_additionalInfo={this.createAPI_additionalInfo}
              ></Plan>
            </Route>
            <Route exact path="/payment">
              <Payment
                state={this.state}
                payment_tapToView={this.payment_tapToView}
                payment_closeBtn={this.payment_closeBtn}
                TandC_componentClick={this.TandC_componentClick}
                payment_CreateAPI={this.payment_CreateAPI}
                addMessageListener={this.addMessageListener}
                nameOnCardOnChange={this.nameOnCardOnChange}
              ></Payment>
            </Route>
            {/* <Route exact path="/update-payment"></Route> */}
            <Route exact path="/update-payment/:paymentdetails">
              <UpdatePayment
                {...this.props}
                updatePaymentNameOnCard={this.updatePaymentNameOnCard}
                handleLegalClick={this.handleLegalClick}
                state={this.state}
                headerHideFun={this.headerHideFun}
                footerHideFun={this.footerHideFun}
              />
            </Route>
            <Route exact path="/useraccount">
              <UserAccount
                state={this.state}
                ua_eyeIcon={this.ua_eyeIcon}
                month={month}
                date={date}
                an_month={an_month}
                an_date={an_date}
                us_hpnStateOnchange={this.us_hpnStateOnchange}
                ua_birthMonthOnchange={this.ua_birthMonthOnchange}
                ua_dateOnchange={this.ua_dateOnchange}
                ua_yearOnchange={this.ua_yearOnchange}
                ua_cinemaOnchange={this.ua_cinemaOnchange}
                ua_an_monthOnchange={this.ua_an_monthOnchange}
                ua_an_dateOnchange={this.ua_an_dateOnchange}
                ua_an_yearOnchange={this.ua_an_yearOnchange}
                ua_counterBtnClick={this.ua_counterBtnClick}
                ua_rewardsTabClick={this.ua_rewardsTabClick}
                ua_passwordPolicyFocus={this.ua_passwordPolicyFocus}
                ua_passwordPolicyBlur={this.ua_passwordPolicyBlur}
                otp_ModalClick={this.otp_ModalClick}
                forgotPassword={this.forgotPassword}
                TandC_componentClick={this.TandC_componentClick}
                NameOnChange={this.NameOnChange}
                fnOnblur={this.fnOnblur}
                lnOnblur={this.lnOnblur}
                signUp_emailOnchange={this.signUp_emailOnchange}
                signUp_emailOnblur={this.signUp_emailOnblur}
                signUp_PasswordOnchangeFun={this.signUp_PasswordOnchangeFun}
                signUp_ConfirmPasswordOnchangeFun={this.signUp_ConfirmPasswordOnchangeFun}
                signUp_ConfirmPasswordPolicyBlur={this.signUp_ConfirmPasswordPolicyBlur}
                ua_addressOnchange={this.ua_addressOnchange}
                ua_zipCodeOnchange={this.ua_zipCodeOnchange}
                ua_zipCodeOnBlur={this.ua_zipCodeOnBlur}
                tc_AcceptClick={this.tc_AcceptClick}
                tc_AgreeClick={this.tc_AgreeClick}
                signUp_mobileOnchangeFun={this.signUp_mobileOnchangeFun}
                signUp_mobileBlur={this.signUp_mobileBlur}
                signupBtnDisabled={this.signupBtnDisabled}
                signIn_emailOnchange={this.signIn_emailOnchange}
                signIn_emailOnblur={this.signIn_emailOnblur}
                signIn_passwordOnblur={this.signIn_passwordOnblur}
                signIn_passwordOnchange={this.signIn_passwordOnchange}
                loginBtnDisabled={this.loginBtnDisabled}
                loginBtnClick={this.loginBtnClick}
                forgot_emailOnchange={this.forgot_emailOnchange}
                forgot_emailOnblur={this.forgot_emailOnblur}
                forgotContinueDisable={this.forgotContinueDisable}
                forgotContineBtn={this.forgotContineBtn}
                loginTab={this.loginTab}
                preferredLocation_TokenAPI={this.preferredLocation_TokenAPI}
                withoutMMR_signupBtn={this.withoutMMR_signupBtn}
                withoutMMR_signupDisabled={this.withoutMMR_signupDisabled}
                signUpTab={this.signUpTab}
                yearCalculationFun={this.yearCalculationFun}
                loyaltyOnchange={this.loyaltyOnchange}
                loyltyOnblur={this.loyltyOnblur}
                loyaltyCheckDisabled={this.loyaltyCheckDisabled}
                loyaltyCheckBtn={this.loyaltyCheckBtn}
                cardTypeOnChange={this.cardTypeOnChange}
                loyaltySignUpBtnDisabled={this.loyaltySignUpBtnDisabled}
                loyaltySignUpBtnOnClick={this.loyaltySignUpBtnOnClick}
                joinCMXTab={this.joinCMXTab}
                login_enterKey={this.login_enterKey}
                get_StateJson={this.get_StateJson}
                forgot_loginClick={this.forgot_loginClick}
              ></UserAccount>
            </Route>
            <Route exact path="/payment-success">
              <Successfull state={this.state} successfullPage_numberToTextConvet={this.successfullPage_numberToTextConvet} successHeaderHome={this.successHeaderHome}></Successfull>
            </Route>
            <Route exact path="/payment-failure">
              <Failed state={this.state} headerHideFun={this.headerHideFun}></Failed>
            </Route>
            <Route exact path="/billing">
              <Billing
                state={this.state}
                getPrice={this.getPrice}
                choosePlans={this.choosePlans}
                selectPlan={this.selectPlan}
                viewAnnualBenefits={this.viewAnnualBenefits}
                viewMonthlyBenefits={this.viewMonthlyBenefits}
                monthlySelectPlan={this.monthlySelectPlan}
              ></Billing>
            </Route>
            <Route exact path="/terms-conditions">
              <TermsConditions state={this.state} tcHeaderClose={this.tcHeaderClose} tandcClose={this.tandcClose}></TermsConditions>
            </Route>
            <Route exact path="/faq">
              <Faq state={this.state} faq_JsonData={this.faq_JsonData}></Faq>
            </Route>
            <Route exact path="/user-guide">
              <UserGuide state={this.state} headerHideFun={this.headerHideFun} guideCloseBtn={this.guideCloseBtn} footerHideFun={this.footerHideFun}></UserGuide>
            </Route>
            <Route exact path="/privacy-policy">
              <PrivacyPolicy state={this.state} privacyClose={this.privacyClose}></PrivacyPolicy>
            </Route>
          </Switch>
        </Router>
        {this.state.footerC_SH && <Footer state={this.state} CMXCinemalogo={this.CMXCinemalogo} />}

        {/* Modal > popups */}
        <ChangeLocationChangeReginModel
          state={this.state}
          show={this.state.plan_pageModalSH}
          onHide={this.Plan_outsideModelClick}
          backdrop="static"
          plan_CL_closeBtn={this.plan_CL_closeBtn}
          ChangeLoc_PopupClick={this.ChangeLoc_PopupClick}
          Plan_CR_onChangeFun={this.Plan_CR_onChangeFun}
          RegionApplyBtn={this.RegionApplyBtn}
          CR_applyDisabled={this.CR_applyDisabled}
        />
        <OtpPopup
          state={this.state}
          show={this.state.otp_pageModalSH}
          onHide={this.otp_outsideModelClick}
          backdrop="static"
          otp_closeBtn={this.otp_closeBtn}
          otpOnChange={this.otpOnChange}
          otp_submitBtn={this.otp_submitBtn}
          otpSubmitDisabled={this.otpSubmitDisabled}
          otp_resendBtn={this.otp_resendBtn}
        />
        <CommonErrorPopup state={this.state} show={this.state.commonErrorPoupSH} onHide={this.commonError_outsideClick} cError_closeBtn={this.cError_closeBtn} backdrop="static" />
        <LoyaltyPopup
          state={this.state}
          show={this.state.loyaltyPopupSH}
          onHide={this.loyaltyPopup_outsideClick}
          loyalty_closeBtn={this.loyalty_closeBtn}
          backdrop="static"
          loyaltyPopupOnchange={this.loyaltyPopupOnchange}
          loyaltyOkBtn={this.loyaltyOkBtn}
        />
        <CongratulationsPopup state={this.state} show={this.state.congratsPopupSH} onHide={this.congrats_outsideClick} backdrop="static" congratsOkBtn={this.congratsOkBtn} />
        <NotifyPopup state={this.state} show={this.state.notifyPopupSH} onHide={this.notify_outsideClick} notify_closeBtn={this.notify_closeBtn} backdrop="static" />
        <TandcPrivacy state={this.state} show={this.state.tncPrivacyPopupSH} onHide={this.tncPrivacy_outsideClick} tncPrivacy_closeBtn={this.tncPrivacy_closeBtn} backdrop="static" />
        <LockinpriodPopup
          state={this.state}
          show={this.state.lockPopupSH}
          onHide={this.lockPopup_outsideClick}
          lockPopup_closeBtn={this.lockPopup_closeBtn}
          backdrop="static"
          selectPlan={this.selectPlan}
        />
      </section>
    );
  }
}

export default App;
